import { InitialGameReveal } from '../../../../components/ui/InitialGameReveal'
import React from 'react'
import {
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
  Keyboard,
  Platform,
  useWindowDimensions,
} from 'react-native'
import { useOrientation } from '../../../../hooks/useOrientation'
import { useLocalSearchParams, useRouter, useFocusEffect, useIsFocused } from 'expo-router'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import { SAFE_AREA_EDGES_BELOW_FILL, TopInsetFill } from '../../../../components/ui/TopInsetFill'
import { useAuth } from '../../../../hooks/useAuth'
import { useStartGame, useAddBot, useUpdateMyColor, useRevokeInvitation, useDeclineInvitation, useRemovePlayer, useTakeSeat, useLeaveGame, useRedeemCode, useDeleteGame, useBootPlayer, useBootPreview } from '../../../../hooks/useGames'
import { BootPlayerConfirmation } from '../../../../components/game/BootPlayerConfirmation'
import { useGameWithMap } from '../../../../hooks/useGameWithMap'
import { useGameEvents } from '../../../../hooks/useGameEvents'
import { useFogSnapshot } from '../../../../hooks/useFogSnapshot'
import { applyFogSnapshot } from '../../../../lib/fogSnapshot'
import { useGameSocket } from '../../../../hooks/useGameSocket'
import { useGamePresence } from '../../../../hooks/useGamePresence'
import { useGameMessages, useChatUnread } from '../../../../hooks/useChat'
import { useFreshChatHighlights } from '../../../../hooks/useFreshChatHighlights'
import { isAppInForeground } from '../../../../lib/appForeground'
import { useDmThreads } from '../../../../hooks/useDirectMessages'
import { unreadByUser, totalUnread } from '../../../../lib/directMessages'
import { useTeamChat } from '../../../../hooks/useTeamChat'
import { teamChatUnread, viewerTeamChat } from '../../../../lib/teamChat'
import {
  reconstructTerritoriesAt,
} from '../../../../lib/historicalState'
import { useMaps } from '../../../../hooks/useMaps'
import { Button } from '../../../../components/ui/Button'
import { useToast } from '../../../../components/ui/Toast'
// getGameState removed — use hydratedState from useGameWithMap instead
import { goBackOrHome } from '../../../../lib/goBack'
import { shouldBeginStartPrep } from '../../../../lib/startPrep'
import { PlayerColorProvider, buildColorBySlot } from '../../../../lib/playerColor'
import { takeSeatJoinRequest } from '../../../../lib/lobbySeats'
import { takeSeatErrorMessage } from '../../../../lib/takeSeat'
import { HttpError } from '../../../../lib/api'
import { classifyGameLoadError, shouldAutoRedeemInvite } from '../../../../lib/gameLoadError'
import { takeoverNoticeForViewer, takeoverNoticeFromError } from '../../../../lib/aiTakeoverNotice'
import { TimeExpiredScreen } from '../../../../components/game/TimeExpiredScreen'
import { useOnForeground } from '../../../../hooks/useOnForeground'
import { useHttpConnectionNotice } from '../../../../hooks/useHttpConnectionNotice'
import { NO_REGION_ID } from '../../../../components/map/RegionAccordion'
import { GameBanner } from '../../../../components/game/GameBanner'
import { GameStartingOverlay } from '../../../../components/game/GameStartingOverlay'
import { PlayerOutModal } from '../../../../components/game/PlayerOutModal'
import {
  advancePlayerOutBaseline,
  filterUnseenPlayerOutNotices,
  type PlayerOutNotice,
} from '../../../../lib/playerOutNotice'
import { PlayerRosterPanel } from '../../../../components/game/PlayerRosterPanel'
import { GameChatDrawer } from '../../../../components/game/GameChatDrawer'
import { ChatLogList, GameChatInputBar, hasChatDraft } from '../../../../components/game/GameChatPanel'
import { ChatRowActionsProvider } from '../../../../components/game/ChatLogRow'
import { useKeyboardTop } from '../../../../hooks/useKeyboardTop'
import { MapChromeProvider } from '../../../../components/map/MapChromeProvider'
import { mapGameLayout } from '../../../../lib/mapGameLayout'
import { shouldEscapeExitSnapshot } from '../../../../lib/snapshotEscape'
import { GameOverlayTopContext } from '../../../../lib/gameOverlayBounds'
import { useTheme } from '../../../../hooks/useTheme'
import { DEFAULT_RESERVED_LEFT_DESKTOP, DEFAULT_RESERVED_LEFT_LANDSCAPE } from '../../../../lib/mapDimensions'
import { getItem, setItem } from '../../../../lib/storage'
import { STORAGE_KEYS } from '../../../../lib/constants'
import { chatButtonAction, inlineChatActive as deriveInlineChatActive, keepChatOnTurnStart } from '../../../../lib/inlineChat'
import { MapChatToggle, MapLogToggle } from '../../../../components/game/MapChatToggle'
import { GameLogControls, gameLogControlParts, type GameLogControlsProps } from '../../../../components/game/GameLogControls'
import { GameLogFilterPanel, GameLogFilterSummary } from '../../../../components/game/GameLogFilterPanel'
import { GameLogSheet } from '../../../../components/game/GameLogSheet'
import { DEFAULT_LOG_FILTERS, chatFilterPlayers, chatAuthorPlayerFilter, hasActiveFilters, presentLogKinds, type ActivityFilterState } from '../../../../lib/activityFilters'
import { GameTopBar, GAME_TOP_BAR_HEIGHT } from '../../../../components/game/GameTopBar'
import { PERSISTENT_CHAT_MIN_HEIGHT, PORTRAIT_GAME_TOP_BAR_HEIGHT, PORTRAIT_GAME_TOP_BAR_PAD } from '../../../../lib/gameChrome'
import { useStableWindowDimensions } from '../../../../hooks/useStableWindowDimensions'
import { EndGameModal } from '../../../../components/game/EndGameModal'
import { currentTurnStartedAt } from '../../../../lib/turnTimes'
import { DiceLuckModal } from '../../../../components/game/DiceLuckModal'
import { TurnInCardsModal } from '../../../../components/cards/TurnInCardsModal'
import { CardHudButton } from '../../../../components/cards/CardHudButton'
import { viewerMustTurnIn, type TurnInStateProjection } from '../../../../lib/cardTurnIn'
import { freeFortifyActionable, shouldAutoOpenTurnInModal } from '../../../../lib/placementFlow'
import { toggleEventSelection } from '../../../../lib/eventSelection'
import type { PlacementAction } from '../../../../lib/placementStack'
import type { PlacementStepMode } from '../../../../components/map/PlacementHud'
import { assignRegionColors, buildRegionAdjacency, BROAD_REGION_PALETTE } from '../../../../components/map/regionColors'
import {
  initialPanForFocus,
  clampZoomScale,
  rescaleAboutCenter,
  MIN_ZOOM_SCALE,
  MAX_ZOOM_SCALE,
  ZOOM_STEP,
} from '../../../../lib/mapZoom'
import type { PanOffset } from '../../../../lib/mapZoom'
import { MapControlsBar } from '../../../../components/map/MapControlsBar'
import { claimGameChatRouteRequest } from '../../../../lib/gameChatRouteParam'
import { armDragHint } from '../../../../lib/dragHint'
import { reportError } from '../../../../lib/reporting'
import { computeDiceLuck, isFogActive, type DiceLuckResult, type GamePlayerResponse } from '@warcarp/api-types'
import { useBotSafetyTimeout } from '../../../../hooks/useBotSafetyTimeout'
import {
  selectTopLevelView,
  selectActivePhaseView,
  deriveIsMyTurn,
  deriveWinnerFromHydratedState,
  deriveViewerIsPlayer,
  shouldShowEndGameModal,
  shouldShowCompletedActivity,
  deriveCurrentTurnPlayerId,
  shouldMountTurnInCardsModal,
  canTurnInCardsNow,
  shouldConnectGameSocket,
} from '../../../../lib/gameScreenState'
import { deriveWinningTeam } from '../../../../lib/winner'
import { fogViewerSide } from '../../../../lib/teamPlay'
import { LobbyView } from '../../../../components/game/screen/LobbyView'
import { setOwnTurnActive } from '../../../../lib/webUpdate'
import { ActiveGameView } from '../../../../components/game/screen/ActiveGameView'
import { buildMapRulesModel, buildTeamRulesInfo, rulesEntryPoints } from '../../../../lib/ruleOverlayModel'
import { overlayPalette } from '../../../../lib/rulesOverlayTheme'
import { tapViewGroup, toggleViewGroupFilter, type ViewGroupState } from '../../../../lib/mapViewGroup'
import { filteredTerritoryIds, playerFilterOptions } from '../../../../lib/playerFilter'
import { PlayerFilterBar } from '../../../../components/map/PlayerFilterBar'
import { useFirstEntryNotice, type FirstEntryKind } from '../../../../lib/firstEntryNotice'
import { FirstEntryCoachMark } from '../../../../components/game/FirstEntryCoachMark'
import { useTeamRulesNotice } from '../../../../lib/teamRulesNotice'
import { TeamRulesModal } from '../../../../components/game/TeamRulesPanel'
import { PLAYER_COLORS, clampPlayerSlot } from '@warcarp/ui'
import { CompleteView } from '../../../../components/game/screen/CompleteView'
import { useGameTutorialMode } from '../../../../hooks/useGameTutorialMode'
import {
  resolveDiceLuckDataState,
  resolveDiceLuckLiveReady,
  shouldShowDiceLuckEntry,
} from '../../../../lib/diceLuck'

// ─── Main screen ──────────────────────────────────────────────────────────────

/** The map bar's players filter and ★ overlay, both closed (lib/mapViewGroup). */
const CLOSED_VIEW_OVERLAY: Pick<ViewGroupState, 'overlay' | 'filter'> = { overlay: null, filter: [] }

export default function GameScreen() {
  const { id, code: inviteCodeParam, chat: chatParam } = useLocalSearchParams<{
    id: string
    code?: string | string[]
    chat?: string | string[]
  }>()
  // Invite code carried in from /invite/<code> → /(app)/join → here. Used to
  // auto-redeem access to a private game so the viewer never retypes it.
  const inviteCode = Array.isArray(inviteCodeParam) ? inviteCodeParam[0] : inviteCodeParam
  const { user, isLoading: authLoading } = useAuth()
  const router = useRouter()
  const isScreenFocused = useIsFocused()
  const { theme } = useTheme()
  const { showToast } = useToast()
  const { enabled: tutorialEnabled, setEnabled: setTutorialEnabled } = useGameTutorialMode(id)
  // Orientation drives where the cog + roster live during ACTIVE/COMPLETE.
  // Portrait: a top header row [cog | spacer | horizontal roster] above the map.
  // Landscape: floating cog overlay top-LEFT (over the map area) +
  // vertical roster strip in the 48px right gutter (map container is
  // narrowed to match).
  const { width: winWidth } = useWindowDimensions()
  // useOrientation publishes only when the orientation boolean flips,
  // not on every intermediate dimension float during the rotation animation.
  // This prevents GameScreen (and the MapView it contains) from re-rendering
  // on every frame of the iOS rotation gesture.
  const { isLandscape } = useOrientation()
  const isDesktop = winWidth >= 1024
  // Wide layouts (landscape desktop windows and tablets, not landscape
  // phones): chat + log are permanently on screen in the side column, the
  // chat input always open — no chat/log toggles. Keyboard-stable height so a
  // soft keyboard can't flip it.
  const { height: stableWinHeight } = useStableWindowDimensions()
  const persistentChatLog = isLandscape && (isDesktop || stableWinHeight >= PERSISTENT_CHAT_MIN_HEIGHT)
  // Chat-only filter for the log beside the chat input: the wide layouts'
  // persistent log, and the phones' log + chat view on your turn.
  const [logChatOnly, setLogChatOnly] = React.useState(false)
  // The log's filters (player, event kind, sort), its filter chips open, and
  // the log grown to just under the header (GameLogSheet). Per game.
  const [logFilters, setLogFilters] = React.useState<ActivityFilterState>(DEFAULT_LOG_FILTERS)
  const [logFiltersOpen, setLogFiltersOpen] = React.useState(false)
  const [logGrown, setLogGrown] = React.useState(false)
  // Safe-area insets so the change-color sheet's header clears the
  // Dynamic Island in portrait (status bar reservation lives on
  // insets.top there) and the iPhone notch in landscape rotations.
  const screenInsets = useSafeAreaInsets()

  // Track the most recent WebSocket connected state in a ref so that the
  // `useGameWithMap` call (which happens before `useGameSocket` in the hook
  // ordering) can read it on re-renders without creating a circular dependency.
  // On the render where `wsConnected` flips true, `wsConnectedRef.current` is
  // already set from the PREVIOUS render, so the poll is suppressed immediately.
  const wsConnectedRef = React.useRef(false)

  const { game, hydratedState, isLoading, error, refetch: refetchGame } = useGameWithMap(id, {
    wsConnected: wsConnectedRef.current,
  })

  // A live GAME_COMPLETE socket frame can arrive before the completion
  // snapshot is included in a subsequent detail response. Fetch that response
  // once so the modal upgrades to the immutable standings instead of relying
  // on the transient terminal state in the socket frame.
  const completionSnapshotRefreshRef = React.useRef<string | null>(null)
  React.useEffect(() => {
    if (
      !id ||
      game?.status !== 'COMPLETE' ||
      game.resultSnapshot !== undefined ||
      completionSnapshotRefreshRef.current === id
    ) {
      return
    }
    completionSnapshotRefreshRef.current = id
    void refetchGame().catch((err: unknown) => {
      reportError(err, {
        tags: { surface: 'game-screen', action: 'load-completion-snapshot' },
        extra: { gameId: id },
      })
    })
  }, [game?.resultSnapshot, game?.status, id, refetchGame])

  // Refetch on screen focus so changes made on a sibling screen
  // (notably /players: kicks, invites, bot adds) show up the instant
  // the host returns to the lobby. Gated on WS-disconnected: when the
  // socket is live, GAME_UPDATED already pushes state, so a focus refetch
  // would be redundant (tab-switching chat→game fires this on every visit).
  useFocusEffect(
    React.useCallback(() => {
      if (!wsConnectedRef.current) void refetchGame()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  )
  const startGame = useStartGame(id ?? '')
  const addBot = useAddBot(id ?? '')
  const updateMyColor = useUpdateMyColor(id ?? '')
  const revokeInvitation = useRevokeInvitation(id ?? '')
  const declineInvitation = useDeclineInvitation(id ?? '')
  const removePlayer = useRemovePlayer(id ?? '')
  const takeSeat = useTakeSeat()
  const [takeSeatPending, setTakeSeatPending] = React.useState<{ slot: number | undefined } | null>(null)
  const leaveGame = useLeaveGame(id ?? '', game?.inviteCode ?? undefined)
  const deleteGame = useDeleteGame(id ?? '')
  const bootPlayer = useBootPlayer(id ?? '')
  const [bootTarget, setBootTarget] = React.useState<{ userId: string; name: string } | null>(null)
  const bootPreview = useBootPreview(id ?? '', bootTarget?.userId ?? null)
  const [bootError, setBootError] = React.useState<string | null>(null)
  const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false)
  const redeemCode = useRedeemCode(id ?? '')

  // Auto-redeem: when we arrive from an invite URL (?code) for a PRIVATE game we
  // can't yet view (GET /:id → 403), redeem the code automatically so the viewer
  // isn't asked to re-enter the code they arrived with. Success grants a pending
  // invitation → the game query re-fires 200 → State B lobby ("join or not").
  // Fires exactly once; on failure we fall through to the manual PIN entry.
  const autoRedeemTriedRef = React.useRef(false)
  const [autoRedeemFailed, setAutoRedeemFailed] = React.useState(false)
  // When the code is valid but the game can't be joined (full / already
  // started), the server 409s with a human message — surface it on landing
  // instead of the (misleading) PIN prompt. Non-409 failures (bad code,
  // network) fall through to the manual PIN entry.
  const [joinBlockedMessage, setJoinBlockedMessage] = React.useState<string | null>(null)
  React.useEffect(() => {
    if (autoRedeemTriedRef.current) return
    if (!shouldAutoRedeemInvite(inviteCode, error)) return
    autoRedeemTriedRef.current = true
    redeemCode.mutate(
      { code: inviteCode! },
      {
        onError: (err) => {
          setAutoRedeemFailed(true)
          if (err instanceof HttpError && err.status === 409) {
            setJoinBlockedMessage(err.message || 'This game is no longer joinable.')
          }
        },
      },
    )
  }, [inviteCode, error, redeemCode])

  // Only members get the live socket. A non-host viewing a pending lobby to
  // join isn't a player yet, so the server rejects their WS with 1008 ("Not a
  // game member") — which the client would answer with a futile token-refresh
  // reconnect loop (banner flashing, refresh-token churn). Non-members fall
  // back to the game query's 15 s poll, which is plenty for a lobby.
  // Incoming secret messages surface via the roster unread badge + a push /
  // email notification (per the recipient's preference) — no in-app toast. The
  // socket still keeps the thread + badge caches fresh (currentUserId lets it
  // resolve the conversation partner for cache updates).
  const { connectedAt: wsConnectedAt, connected: wsConnected } = useGameSocket(
    id,
    shouldConnectGameSocket({ gameId: id, userId: user?.id, players: game?.players }),
    { currentUserId: user?.id },
  )
  // Sync the ref so the next render's useGameWithMap call sees the current
  // connected state. Mutating a ref during render is valid React — it's
  // immediately visible to the next render without scheduling a state update.
  wsConnectedRef.current = wsConnected

  // Safety timeout — perf-plan PR E.3.
  // Arms a 30s refetch fallback when the game is on a bot's turn. This
  // guarantees the client never sits indefinitely waiting for a WS
  // GAME_UPDATED event that may have been dropped on a cellular reconnect.
  //
  // RULES-OF-HOOKS: must live above the `if (isLoading)` early return below.
  useBotSafetyTimeout(id, game, {
    onStuck: () => {
      showToast('Taking longer than usual — checking for updates…', 'info')
    },
  })

  // HTTP and confirmed offline state drive the notice; sockets remain secondary.
  const connectionBanner = useHttpConnectionNotice(id)

  const rawPresence = useGamePresence(id)
  // The server's PRESENCE_UPDATE broadcast doesn't always include the
  // viewer themselves (timing of the FOCUS round-trip on iOS Safari /
  // iOS native — the broadcast can fire BEFORE the local socket
  // registers as online). Augment the set with the viewer's userId so
  // the active-turn halo on the viewer's own avatar always renders;
  // the alternative is a brief "no halo on my own avatar while it's
  // my turn" flicker that reads as a bug.
  const presence = React.useMemo(() => {
    if (!user?.id) return rawPresence
    if (rawPresence.has(user.id)) return rawPresence
    const next = new Set(rawPresence)
    next.add(user.id)
    return next
  }, [rawPresence, user?.id])

  // Chat is player-only. Gate the fetch on membership so a non-member viewing
  // the lobby (State B) or a viewer mid-invite-redeem doesn't 403 against /chat.
  const viewerIsMember = !!(user?.id && game?.players?.some((p) => p.userId === user.id))
  const canOpenGameChat = viewerIsMember && (game?.status === 'ACTIVE' || game?.status === 'COMPLETE')
  const { data: messages = [], isSuccess: messagesReady } = useGameMessages(id ?? '', viewerIsMember)
  const {
    unreadCount,
    sessionSeenId,
    persistedSeenId,
    onChatOpen,
    markSeen,
    markSeenThrough,
    captureSessionBoundary,
  } = useChatUnread(id ?? '', messages)

  // Secret-message threads (player-only) → per-player unread badges in the roster.
  const { data: dmThreads = [] } = useDmThreads(id ?? '', viewerIsMember)
  const dmUnreadByUser = React.useMemo(() => unreadByUser(dmThreads), [dmThreads])
  // Team games: the viewer's secret team chat. Its unread count goes on the
  // team header's bubble in the drawer and joins the player dots' total.
  const viewerChatTeam = viewerTeamChat(game, user?.id)
  const { data: teamChat } = useTeamChat(id ?? '', viewerChatTeam !== null)
  const teamUnread = viewerChatTeam ? teamChatUnread(teamChat, user?.id) : 0
  const dmUnreadTotal = React.useMemo(() => totalUnread(dmThreads), [dmThreads]) + teamUnread

  // Map friendly display name — used in the LOBBY map tile.
  const { data: maps } = useMaps()
  const mapDisplayName = React.useMemo(() => {
    if (!game?.mapId) return null
    return maps?.find((m) => m.id === game.mapId)?.name ?? null
  }, [maps, game?.mapId])

  // (Lobby Start sends no config — the game's config was persisted to
  // setupConfig at creation; performGameStart uses that. Sending a config
  // here previously overrode the saved one with hardcoded defaults.)

  // End-game modal is dismissable per-view. We only need a flag that
  // flips to true after the user closes the modal; remounting the
  // screen resets it, which is intentional — the modal pops again on
  // the next visit so the user can't miss the outcome.
  const [endGameDismissed, setEndGameDismissed] = React.useState(false)
  const showResults = React.useCallback(() => setEndGameDismissed(false), [])
  // Card turn-in modal visibility. We auto-open when the engine sets
  // `mustTurnInCards` so the player can't accidentally miss the block;
  // they can still close again only after the flag drops (see modal).
  const [cardsModalOpen, setCardsModalOpen] = React.useState(false)
  const [chatOpen, setChatOpen] = React.useState(false)
  const [chatFocusMessageId, setChatFocusMessageId] = React.useState<string | undefined>()
  const [chatDrawerMounted, setChatDrawerMounted] = React.useState(false)
  // Inline chat bar (GameChatInputBar, under the map controls). Off-turn its
  // open state is remembered per device (the map bar's log-chat button on
  // phones; on by default); on your turn it lasts for the turn.
  const [inlineChatMode, setInlineChatMode] = React.useState(true)
  // Your turn: what fills the area under the map — the turn controls (the
  // default), the chat, or the log. Exclusive; resets each turn.
  const [turnPanel, setTurnPanel] = React.useState<'controls' | 'chat' | 'log'>('controls')
  const turnChatOpen = turnPanel === 'chat'
  const [inlineChatInputFocused, setInlineChatInputFocused] = React.useState(false)
  React.useEffect(() => {
    let active = true
    getItem(STORAGE_KEYS.GAME_CHAT_BAR_OFF_TURN)
      .then((stored) => { if (active) setInlineChatMode(stored !== 'false') })
      .catch((error: unknown) => {
        reportError(error instanceof Error ? error : new Error(String(error)), {
          tags: { area: 'inline-chat', action: 'load-preference' },
        })
      })
    return () => { active = false }
  }, [])
  const chatDrawerUnmountTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  // Roster panel expanded state. Lifted here so the collapsed strip
  // (rendered INSIDE MapView via `rightOverlay` to centre on the map)
  // and the expanded slide-in panel (rendered at the screen overlay
  // level so it can dim the whole viewport) can share it.
  const [rosterExpanded, setRosterExpanded] = React.useState(false)
  const [diceLuckOpen, setDiceLuckOpen] = React.useState(false)
  const [diceLuckLiveReady, setDiceLuckLiveReady] = React.useState(false)
  const [diceLuckPlayerId, setDiceLuckPlayerId] = React.useState<string | null>(null)
  const dismissChat = React.useCallback(() => {
    Keyboard.dismiss()
    setChatOpen(false)
    if (chatDrawerUnmountTimer.current !== null) clearTimeout(chatDrawerUnmountTimer.current)
    chatDrawerUnmountTimer.current = setTimeout(() => {
      setChatDrawerMounted(false)
      chatDrawerUnmountTimer.current = null
    }, 280)
  }, [])
  const closeChat = React.useCallback(() => {
    markSeen()
    dismissChat()
  }, [dismissChat, markSeen])
  const openChatAt = React.useCallback((focusMessageId?: string) => {
    if (!canOpenGameChat) return
    Keyboard.dismiss()
    setChatFocusMessageId(focusMessageId)
    if (chatOpen) return
    setRosterExpanded(false)
    setDiceLuckOpen(false)
    setCardsModalOpen(false)
    captureSessionBoundary()
    onChatOpen()
    if (chatDrawerUnmountTimer.current !== null) {
      clearTimeout(chatDrawerUnmountTimer.current)
      chatDrawerUnmountTimer.current = null
    }
    setChatDrawerMounted(true)
    setChatOpen(true)
  }, [canOpenGameChat, captureSessionBoundary, chatOpen, onChatOpen])
  // Hook-safe copy of the turn/snapshot facts the 💬 button needs (the
  // canonical isMyTurn is derived after the early returns below).
  const viewerSlotEarly = game?.players.find((p) => p.userId === user?.id)?.slot
  const isMyTurnEarly = deriveIsMyTurn({
    gameStatus: game?.status ?? '',
    myPlayerSlot: viewerSlotEarly,
    gameState: hydratedState,
  })
  // The web "update ready" toast waits while it's your turn on this board
  // (lib/webUpdate): it shows once the turn ends, never mid-turn.
  const ownTurnOnBoard = isMyTurnEarly && isScreenFocused
  React.useEffect(() => {
    setOwnTurnActive(ownTurnOnBoard)
    return () => setOwnTurnActive(false)
  }, [ownTurnOnBoard])
  const [historicalEventIndex, setHistoricalEventIndex] = React.useState<number | null>(null)
  // Fog of war while the game is live: the viewer holds only their own
  // redacted log, so snapshots come from the server as they could see the
  // board then (useFogSnapshot), and dice luck covers only their side
  // (docs/fog-of-war/README.md).
  const fogActiveGame = game?.status === 'ACTIVE' && isFogActive(hydratedState?.config)
  const fogSnapshot = useFogSnapshot(id, historicalEventIndex, fogActiveGame)
  const inSnapshot = historicalEventIndex !== null
  // Desktop/web: Escape leaves the snapshot for the live game (overlays on
  // top close first — they own Escape while open).
  const snapshotOverlayOpen = cardsModalOpen || chatOpen || rosterExpanded || diceLuckOpen
  // Arrow keys step the snapshot log under the same conditions (the snapshot
  // view itself also ignores them while a text field has focus).
  const snapshotArrowKeysEnabled = inSnapshot && isScreenFocused && !snapshotOverlayOpen
  const snapshotEscapeState = React.useRef({ inSnapshot, screenFocused: isScreenFocused, overlayOpen: false })
  snapshotEscapeState.current = {
    inSnapshot,
    screenFocused: isScreenFocused,
    overlayOpen: snapshotOverlayOpen,
  }
  React.useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return
    const onKey = (event: KeyboardEvent) => {
      if (shouldEscapeExitSnapshot({ key: event.key, ...snapshotEscapeState.current })) {
        setHistoricalEventIndex(null)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])
  // Landscape phones (short landscape screens, not the wide layouts): no chat
  // input at all — the side column shows the log with its chat lines, and on
  // your turn the log-chat button opens that same log.
  const chatInputDisabled = isLandscape && !persistentChatLog
  const inlineChatOn = deriveInlineChatActive({
    canChat: canOpenGameChat && !chatInputDisabled,
    status: game?.status,
    inSnapshot,
    isMyTurn: isMyTurnEarly,
    // Off-turn the chat input is simply always open (no toggle): desktop, the
    // wide layouts, and portrait phones. (Landscape phones have no input.)
    chatMode: isDesktop || persistentChatLog || inlineChatMode,
    turnChatOpen: turnChatOpen || persistentChatLog,
  })
  // A new turn of yours starts on the turn controls — unless you were mid-
  // message in the chat (input focused or unsent text): then the chat stays
  // open so the draft and keyboard survive. Adjusted during render (not in an
  // effect) so the input never unmounts for a frame on the turn change.
  const [seenMyTurn, setSeenMyTurn] = React.useState(isMyTurnEarly)
  if (seenMyTurn !== isMyTurnEarly) {
    setSeenMyTurn(isMyTurnEarly)
    if (isMyTurnEarly) {
      // Your turn opens on the turn controls, not a grown log.
      setLogGrown(false)
      setTurnPanel(keepChatOnTurnStart({
        // Off-turn chat state (inlineChatOn has already flipped to the
        // your-turn rule on this render).
        chatWasOpen: isDesktop || inlineChatMode,
        inputFocused: inlineChatInputFocused,
        hasDraft: hasChatDraft(id ?? ''),
      }) ? 'chat' : 'controls')
    }
  }
  React.useEffect(() => {
    if (!inlineChatOn) setInlineChatInputFocused(false)
  }, [inlineChatOn])
  // The chat-only filter needs a chat line to show: hidden (and ignored if
  // left on) while the game has none, so the log never goes blank.
  const hasChatMessages = messages.length > 0
  const chatOnlyActive = logChatOnly && hasChatMessages
  const chatAuthors = React.useMemo(() => chatFilterPlayers(game?.players ?? [], messages), [game?.players, messages])
  // Switching from ALL to CHAT must not retain a hidden, empty player filter.
  const chatPlayerFilter = chatOnlyActive && messagesReady
    ? chatAuthorPlayerFilter(logFilters.playerFilter, chatAuthors) : logFilters.playerFilter
  if (chatPlayerFilter !== logFilters.playerFilter) {
    setLogFilters({ ...logFilters, playerFilter: chatPlayerFilter })
  }
  // Chat-only switched on by the log-chat button's unread badge lasts only
  // while the view it opened stays: closed (your turn: back to the turn
  // controls; off-turn: the chat bar hidden) or the turn changing makes the
  // log whole again. (Toggling the filter yourself keeps your choice.) Each
  // game starts unfiltered. Adjusted during render, so no filtered frame.
  // 'mine' / 'theirs': whose turn it was opened on.
  const [chatOnlyFromBadge, setChatOnlyFromBadge] = React.useState<false | 'mine' | 'theirs'>(false)
  if (chatOnlyFromBadge && (
    (chatOnlyFromBadge === 'mine') !== isMyTurnEarly ||
    (isMyTurnEarly ? turnPanel === 'controls' : !inlineChatOn)
  )) {
    setChatOnlyFromBadge(false)
    setLogChatOnly(false)
  }
  const [chatOnlyGameId, setChatOnlyGameId] = React.useState(id)
  if (chatOnlyGameId !== id) {
    setChatOnlyGameId(id)
    setChatOnlyFromBadge(false)
    setLogChatOnly(false)
    setLogFilters(DEFAULT_LOG_FILTERS)
    setLogFiltersOpen(false)
    setLogGrown(false)
  }
  // A chat line is read once it has been on screen in a log list while you're
  // live: this screen focused, the app in the foreground (lib/chatSeen). A
  // line pushed out of view before you saw it stays unread, so the map bar's
  // log-chat button still badges it. Each list's on-screen lines are kept, so
  // lines that arrived while you were away count once you're back.
  const chatRowsOnScreen = React.useRef(new Map<string, string[]>())
  const chatSeenLive = isScreenFocused && !inSnapshot
  const markOnScreenChatSeen = React.useCallback(() => {
    if (!chatSeenLive || !isAppInForeground()) return
    markSeenThrough([...chatRowsOnScreen.current.values()].flat())
  }, [chatSeenLive, markSeenThrough])
  const onChatRowsSeen = React.useCallback((listId: string, messageIds: string[]) => {
    if (messageIds.length) chatRowsOnScreen.current.set(listId, messageIds)
    else chatRowsOnScreen.current.delete(listId)
    markOnScreenChatSeen()
  }, [markOnScreenChatSeen])
  // Back on this screen, or the read marker / messages loaded or changed.
  React.useEffect(() => { markOnScreenChatSeen() }, [markOnScreenChatSeen])
  useOnForeground(markOnScreenChatSeen)
  // Listen whenever the chat bar is open — NOT only once the input is
  // focused: the keyboard's show event fires during that same focus, so a
  // listener attached on focus missed it and the panel never docked.
  const keyboardTop = useKeyboardTop(inlineChatOn)
  const inlineChatDockTop = inlineChatOn && inlineChatInputFocused && !isLandscape ? keyboardTop : null

  // Open/close the inline chat bar. Off-turn the choice is remembered on this
  // device; on your turn it only lasts for the turn.
  const setInlineChatOpen = React.useCallback((open: boolean) => {
    if (!open) Keyboard.dismiss()
    if (isMyTurnEarly) {
      setTurnPanel(open ? 'chat' : 'controls')
      return
    }
    setInlineChatMode(open)
    setItem(STORAGE_KEYS.GAME_CHAT_BAR_OFF_TURN, String(open)).catch((error: unknown) => {
      reportError(error instanceof Error ? error : new Error(String(error)), {
        tags: { area: 'inline-chat', action: 'save-preference' },
      })
    })
  }, [isMyTurnEarly])

  // Chat on/off (map-bar button on phones, top-bar button on desktop). On the
  // live board "on" opens the inline chat; where there is none (completed
  // game) it opens the conversation drawer. "Off" is the default view.
  const selectChatSide = React.useCallback((chat: boolean) => {
    if (chatButtonAction({ status: game?.status, inSnapshot }) === 'toggle-drawer') {
      if (chat && !chatOpen) openChatAt()
      if (!chat && chatOpen) closeChat()
      return
    }
    if (chatOpen) closeChat()
    setInlineChatOpen(chat)
  }, [chatOpen, closeChat, game?.status, inSnapshot, openChatAt, setInlineChatOpen])

  const consumedChatParamRef = React.useRef<string | null>(null)
  React.useEffect(() => {
    // Keep a focused chat link until auth has settled so membership checks do
    // not consume it during the initial null-user hydration frame.
    if (!game || authLoading) return
    const claimed = claimGameChatRouteRequest(chatParam, consumedChatParamRef.current)
    consumedChatParamRef.current = claimed.consumedValue
    if (!claimed.request) return
    router.setParams({ chat: undefined } as never)
    if (canOpenGameChat) openChatAt(claimed.request.focusMessageId)
  }, [authLoading, canOpenGameChat, chatParam, game, openChatAt, router])
  const toggleRoster = React.useCallback(() => {
    if (chatOpen) closeChat()
    setRosterExpanded((expanded) => !expanded)
  }, [chatOpen, closeChat])
  const openDiceLuck = React.useCallback((playerId: string | null = null) => {
    // Dice Luck replaces the roster instead of stacking over it. Keeping the
    // animated drawer mounted behind the modal can preserve an in-flight web
    // transform and reveal the drawer again when the modal closes.
    if (chatOpen) closeChat()
    setRosterExpanded(false)
    setDiceLuckPlayerId(playerId)
    setDiceLuckOpen(true)
  }, [chatOpen, closeChat])
  const openCardsModal = React.useCallback(() => {
    if (chatOpen) closeChat()
    setCardsModalOpen(true)
  }, [chatOpen, closeChat])
  // Expo Router retains prior screens in the native stack. Always dismiss this
  // route's native modal when it blurs so a second visit to the same game can
  // never open another cards modal over the retained one.
  useFocusEffect(
    React.useCallback(() => () => {
      setCardsModalOpen(false)
      setChatOpen(false)
      setChatDrawerMounted(false)
      if (chatDrawerUnmountTimer.current !== null) {
        clearTimeout(chatDrawerUnmountTimer.current)
        chatDrawerUnmountTimer.current = null
      }
      setDiceLuckOpen(false)
      setDiceLuckPlayerId(null)
    }, []),
  )
  // Pending troop placements, lifted here (not inside ReinforceUI /
  // PostElimPlacementUI) so they SURVIVE a trip to the regions overlay — which
  // unmounts the placement UI and would otherwise wipe the staged decisions.
  // Reset only when the placement session (phase + acting turn) changes; see the
  // effect after gameState is derived.
  const [placementStack, setPlacementStack] = React.useState<PlacementAction[]>([])
  const [placementStepMode, setPlacementStepMode] = React.useState<PlacementStepMode>(1)
  // Clear staged placements only when the placement SESSION changes — i.e. the
  // engine phase or the acting turn moves on. Toggling the regions overlay leaves
  // both unchanged, so pending troops persist across it (the bug this fixes).
  // Declared here (above any early return) to satisfy rules-of-hooks; keyed on a
  // string so a fresh WS state object with the same phase/turn doesn't reset it.
  const placementSessionKey = hydratedState
    ? `${hydratedState.phase}:${hydratedState.turnIndex}`
    : ''
  React.useEffect(() => {
    setPlacementStack([])
    setPlacementStepMode(1)
  }, [placementSessionKey])
  // Use parent-local coordinates: the drawer is an absolute sibling inside
  // this SafeAreaView. Window coordinates include native screen/status offsets
  // and measuring a collapsed native wrapper can fail altogether.
  const [portraitTopBarHeight, setPortraitTopBarHeight] = React.useState(PORTRAIT_GAME_TOP_BAR_HEIGHT)
  const [navBarBottomY, setNavBarBottomY] = React.useState<number | null>(null)

  // Player-out notices — a small auto-dismissing modal per player who just left
  // (eliminated or resigned), shown to every live viewer (see the effect below).
  const [eliminationQueue, setEliminationQueue] = React.useState<PlayerOutNotice[]>([])
  // Baseline of the eliminated list. null until the first state arrives, so we
  // never fire the modal for eliminations that were already in the snapshot
  // when the viewer opened the game (only NEW ones while they're live).
  const prevEliminatedRef = React.useRef<string[] | null>(null)
  // A player can only leave a game once. Keep this independent of the current
  // eliminated-list baseline so a stale frame cannot make the same banner
  // visible again after it has already been shown.
  const shownPlayerOutSlotsRef = React.useRef<Set<number>>(new Set())

  // Detect newly-eliminated players as pushed state updates the cache. Keyed on
  // the joined eliminated list so it re-runs when that list changes AND on
  // `stateReady` so it also runs the instant state first loads. The load
  // dependency is load-bearing: without it the baseline is seeded lazily on the
  // first `eliminated` change, which swallows the FIRST elimination of a game
  // (the seeding branch returns before notifying). Seeding at load time instead
  // means the first elimination diffs against a real baseline and fires. The
  // acting player's attack response and every other live viewer's GAME_UPDATED
  // both flow through here, so all live viewers see the modal; absent viewers
  // get the backend push instead.
  const stateReady = hydratedState != null
  const eliminatedKey = (hydratedState?.eliminated ?? []).join(',')
  React.useEffect(() => {
    if (!hydratedState) return
    const isInitialLoad = prevEliminatedRef.current === null
    const { baseline, notices } = advancePlayerOutBaseline(
      prevEliminatedRef.current,
      hydratedState.eliminated ?? [],
      hydratedState.events ?? [],
    )
    // Seed already-out players too. They are not shown on first load, and
    // must not become banners later if an old frame temporarily omits them.
    if (isInitialLoad) {
      for (const slot of baseline) shownPlayerOutSlotsRef.current.add(Number(slot))
    }
    prevEliminatedRef.current = baseline
    const unseenNotices = filterUnseenPlayerOutNotices(
      notices,
      shownPlayerOutSlotsRef.current,
    )
    for (const notice of unseenNotices) shownPlayerOutSlotsRef.current.add(notice.slot)
    if (unseenNotices.length > 0) {
      setEliminationQueue((q) => [...q, ...unseenNotices])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eliminatedKey, stateReady])

  // Color-change sheet — visible in LOBBY when viewer is a player.
  const [colorPickerOpen, setColorPickerOpen] = React.useState(false)

  // Code redemption modal — shown when GET /games/:id returns 403 (private
  // uninvited). The viewer enters the 4-digit PIN to get a pending invitation.
  const [codeModalOpen, setCodeModalOpen] = React.useState(false)
  const [redeemPin, setRedeemPin] = React.useState('')
  const [redeemError, setRedeemError] = React.useState<string | null>(null)

  // Region details overlay — toggleable from the cog menu. When on, the
  // action sidebar is replaced by RegionDetailsPanel and the map shows
  // region bonus badges. Resets to off on unmount (component-level state).
  const [regionDetailsMode, setRegionDetailsMode] = React.useState(false)
  // The map bar's momentary segments: the players filter bar (with its chip
  // selection) or the ★ map rules overlay. lib/mapViewGroup owns the rules:
  // closing the filter bar by any route clears its selection.
  const [viewOverlay, setViewOverlay] = React.useState<Pick<ViewGroupState, 'overlay' | 'filter'>>(CLOSED_VIEW_OVERLAY)
  // The last players-filter selection, so reopening the bar brings it back
  // (maintainer, 2026-11-03). Per game, kept on this device.
  const [lastPlayerFilter, setLastPlayerFilter] = React.useState<readonly string[]>([])
  const lastFilterKey = id ? `playerFilter.v1.${String(id).replace(/[^A-Za-z0-9_-]/g, '_')}` : null
  React.useEffect(() => {
    if (!lastFilterKey) return
    let active = true
    getItem(lastFilterKey)
      .then((raw) => { if (active && raw) setLastPlayerFilter(raw.split(',').filter(Boolean)) })
      .catch((error) => reportError(error, { tags: { surface: 'player-filter', action: 'read' } }))
    return () => { active = false }
  }, [lastFilterKey])
  // The ★ segment, for the first-entry coach mark to point at.
  const rulesAnchorRef = React.useRef<View>(null)
  // The coach mark on screen (latched until its collapse tip finishes).
  const [coachShown, setCoachShown] = React.useState<FirstEntryKind | null>(null)
  const [focusedRegionId, setFocusedRegionId] = React.useState<string | null>(null)
  // Territory selected from a map tap inside the 🗺 overlay. Region
  // highlights + bonus badges are always on while regionDetailsMode is
  // active; tapping a territory just adds an inspector card and lights
  // up its adjacencies.
  const [focusedDetailTerritoryId, setFocusedDetailTerritoryId] = React.useState<
    string | null
  >(null)
  // Bumped by the map Reset control to send the region-details list back to
  // the top (see RegionDetailsPanel.resetSignal).
  const [regionDetailsResetSignal, setRegionDetailsResetSignal] = React.useState(0)

  // Zoom-and-pan state. Hoisted here so it persists across phase changes
  // within a turn (switching reinforce → attack doesn't blow away the
  // current zoom/pan position). Zoom is ALWAYS on now — the map controls bar
  // (beneath the map) owns reset/+/- ; there is no enable/disable toggle. The
  // default framing is fully zoomed out (whole map) at MIN_ZOOM_SCALE.
  const zoomEnabled = true
  const [zoomScale, setZoomScale] = React.useState(MIN_ZOOM_SCALE)
  const [panOffset, setPanOffset] = React.useState<PanOffset>({ tx: 0, ty: 0 })

  // +/- zoom from the on-map buttons. MapView clamps the scale and emits the
  // recentred pan via onPanChange; we just store the new scale here. Defined
  // here with the other top-level hooks (NOT lower in the body) so it sits
  // above the early returns below — a misplaced useCallback there triggered a
  // "rendered more hooks than during the previous render" crash.
  const handleZoomScaleChange = React.useCallback((scale: number) => {
    setZoomScale(scale)
  }, [])

  // Arm the one-shot map drag-hint compass once per game-screen visit (per id).
  // MapView consumes it on the first zoom-in; navigating away + back re-arms.
  React.useEffect(() => {
    armDragHint()
  }, [id])


  // Time-machine mode. Non-null = the user tapped an event row in the
  // activity feed and is now viewing the map as it was at that event
  // index. null = live state. Always renders the spectator-style
  // layout (activity feed on the side, map in the middle, banner
  // overlay on top) regardless of whose turn it actually is — the
  // user is in review mode, not play mode.
  //
  // Hook MUST live above the early-return blocks below — same
  // Rules-of-Hooks contract as gameStateForColors. Putting it lower
  // (after the isLoading guard) tripped React error #310 the moment
  // the game finished loading: the previous render had skipped the
  // useState (early-returned the spinner), the next render included
  // it, hook counts didn't match, the screen blew up. (The useState itself is
  // declared further up, with the inline-chat state that also reads it.)
  // Tapping the row that is ALREADY selected clears it and returns to live —
  // see lib/eventSelection for the rule and why it is not inlined.
  const toggleHistoricalEvent = React.useCallback((index: number) => {
    setHistoricalEventIndex((prev) => toggleEventSelection(prev, index))
  }, [])

  // Region/territory inspector toggles for the regionDetailsMode overlay.
  // Hooks MUST live above the early-return blocks below — same
  // Rules-of-Hooks contract as historicalEventIndex above. Placing
  // these as `useCallback` below the `isLoading` / `error || !game` /
  // `COMPLETE` guards tripped React error #310 in production web
  // (Tier 1 PR #354): on the loading render path the early return
  // skipped these hooks; on the loaded render path both hooks ran;
  // the hook count mismatch crashed the screen.
  // territory → regionId lookup (stable for a game) so tapping a territory
  // can expand its parent region in the region-details accordion.
  const territoryRegionById = React.useMemo(() => {
    const out: Record<string, string> = {}
    for (const t of hydratedState?.map.territories ?? []) {
      // Region-less territories map to the accordion's synthetic "Unaligned"
      // group so tapping one still expands somewhere.
      out[t.id] = t.regionId ?? NO_REGION_ID
    }
    return out
  }, [hydratedState?.map])

  const handleDetailRegionPress = React.useCallback((regionId: string) => {
    setFocusedRegionId((prev) => (prev === regionId ? null : regionId))
    setFocusedDetailTerritoryId(null)
  }, [])
  const handleDetailTerritoryPress = React.useCallback(
    (territoryId: string) => {
      // Select the territory AND expand its region so it shows highlighted in
      // the region-details accordion under its region tile.
      setFocusedDetailTerritoryId((prev) => (prev === territoryId ? null : territoryId))
      setFocusedRegionId(territoryRegionById[territoryId] ?? null)
    },
    [territoryRegionById],
  )
  const handleDetailBackgroundPress = React.useCallback(() => {
    // Tap on the ocean / non-territory area in the regions view → deselect AND
    // scroll the list back to the top (resetSignal → RegionDetailsPanel).
    setFocusedDetailTerritoryId(null)
    setFocusedRegionId(null)
    setRegionDetailsResetSignal((n) => n + 1)
  }, [])

  // Region colour map — shared between MapView (for bonus badges) and
  // RegionDetailsPanel (colour chips in the list). Derived once per map
  // so both consumers agree without duplicating the graph-colour logic.
  // Must be above the early-return blocks to satisfy the Rules of Hooks.
  // hydratedState already combines live territory data with static map geometry.
  // Alias to gameStateForColors for the region-color computation below.
  const gameStateForColors = hydratedState
  const regionColorById = React.useMemo(() => {
    if (!gameStateForColors) return {} as Record<string, string>
    const adj = buildRegionAdjacency(
      gameStateForColors.map.territories,
      gameStateForColors.map.regions,
    )
    return assignRegionColors(gameStateForColors.map.regions, adj, BROAD_REGION_PALETTE)
  }, [gameStateForColors])

  // Auto-open the turn-in modal when the engine flags a forced turn-in
  // (≥5 cards at placement entry, or after an elimination) — but ONLY when
  // it is the viewer's own turn.
  //
  // `mustTurnInCards` is a single GLOBAL flag tracking whoever is the
  // CURRENT player. During bot turns the WS GAME_STATE_PATCH events carry a
  // bot's `mustTurnInCards = true` (a bot that entered placement holding ≥5
  // cards, before it greedily trades in). Without the turn guard that
  // bot-owned flag popped this modal on the human's screen — showing the
  // human's own (possibly setless, <5) hand and obscuring the bot's moves.
  // Gating on "viewer is the current player" means the prompt only fires
  // when the engine genuinely requires THIS viewer to trade in; in that
  // case the engine computed the flag from the viewer's own hand, so a
  // separate hand-size check here would be redundant.
  // Post-elimination sequencing (see lib/placementFlow): the forced turn-in
  // modal auto-opens only once the flow reaches the 'forced-turn-in' step —
  // i.e. every "X was eliminated" banner has dismissed AND any actionable
  // free-fortify has been resolved. This fixes the soft-lock where an
  // eliminating conquest that left nothing to fortify kept lastConquest set,
  // so the modal (which used to defer on the raw flag) never opened while the
  // backend blocked placement. Order: banner → free-fortify → turn-in → place.
  const viewerSlotId = game?.players.find((p) => p.userId === user?.id)?.slot
  const turnInState = game?.state as unknown as TurnInStateProjection | undefined
  const mustTurnInCards = viewerMustTurnIn(turnInState, viewerSlotId)
  // Free-fortify actionability MUST read the HYDRATED state: the raw wire
  // `game.state` is slim post-Tier-3 (state.territories, NO state.map), so
  // reading `game.state.map.territories` yielded an empty list → the gate
  // thought no fortify was pending and opened the turn-in ahead of it.
  // hydratedState carries map.territories (armies) + lastConquest, matching
  // what PostElimPlacementUI uses, so the two agree exactly.
  const freeFortifyPending = freeFortifyActionable(
    hydratedState?.lastConquest,
    hydratedState?.map.territories ?? [],
  )
  const autoOpenTurnIn = shouldAutoOpenTurnInModal({
    bannerPending: eliminationQueue.length > 0,
    freeFortifyPending,
    mustTurnIn: mustTurnInCards,
  })
  React.useEffect(() => {
    if (isScreenFocused && autoOpenTurnIn && !chatOpen) setCardsModalOpen(true)
  }, [autoOpenTurnIn, chatOpen, isScreenFocused])

  // Full event log for the time-machine — fetched from `/events` (cached) only
  // while a snapshot is open. The live wire only carries a recent tail, so
  // reconstruction MUST replay the full log; `historicalEventIndex` is an
  // ABSOLUTE index into it (the live feed maps its tail rows via an offset —
  // see ActiveGameView). Lazy-enabled so normal play never fetches the full log.
  // (`inSnapshot` is declared with the inline-chat state above.)
  const diceLuckRequested = diceLuckOpen || rosterExpanded
  const needsFullEvents = inSnapshot || diceLuckRequested
  const {
    events: fullEvents,
    eventCount: cachedEventCount,
    isLoading: eventsLoading,
    isRefetching: eventsRefetching,
    error: eventsError,
    refetch: refetchEvents,
  } = useGameEvents(id ?? '', {
    enabled: needsFullEvents,
    // Fog games: re-read the whole (no longer redacted) log once the game ends.
    resetKey: isFogActive(hydratedState?.config) ? game?.status : undefined,
  })
  // The log filter's event-kind chips: only kinds this game's log has. The
  // full log shares the cache the log itself fills (it fetches it whenever it
  // shows); until then the live tail stands in.
  const wireEvents = gameStateForColors?.events
  const logFilterKinds = React.useMemo(
    () => presentLogKinds((fullEvents.length > 0 ? fullEvents : wireEvents ?? []).map((event) => ({ kinds: [event.kind] }))),
    [fullEvents, wireEvents],
  )

  // The live wire's eventCount is always fresh (WS/poll). If the cached
  // `/events` log is behind it — we took turns since it was last fetched — pull
  // fresh events so the snapshot reflects the latest turns instead of replaying
  // a stale (short) array and showing an out-of-date board.
  const wireEventCount = gameStateForColors?.eventCount ?? 0
  React.useEffect(() => {
    if (needsFullEvents && cachedEventCount < wireEventCount) {
      void refetchEvents()
    }
  }, [needsFullEvents, cachedEventCount, wireEventCount, refetchEvents])

  const snapshotDiceLuck = game?.resultSnapshot?.diceLuck ?? null
  const showDiceLuckEntry = shouldShowDiceLuckEntry({
    gameStatus: game?.status,
    wireEventCount,
    hasSnapshot: Boolean(snapshotDiceLuck),
  })
  const [retainedDiceLuck, setRetainedDiceLuck] = React.useState<{
    gameId: string
    result: DiceLuckResult
  } | null>(null)
  const retainedDiceLuckForGame = retainedDiceLuck?.gameId === id
    ? retainedDiceLuck
    : null
  const diceLuckDataState = resolveDiceLuckDataState({
    visible: diceLuckRequested,
    gameStatus: game?.status,
    wireEventCount,
    cachedEventCount,
    loadedEventCount: fullEvents.length,
    queryLoading: eventsLoading,
    queryRefetching: eventsRefetching,
    queryError: Boolean(eventsError),
    hasSnapshot: Boolean(snapshotDiceLuck),
    hasRetainedResult: Boolean(retainedDiceLuckForGame?.result),
  })
  const diceLuckIsLive = resolveDiceLuckLiveReady(diceLuckLiveReady, {
    modalOpen: diceLuckOpen,
    activeGame: game?.status === 'ACTIVE',
    socketConnected: wsConnected,
    eventLogSynchronized: diceLuckDataState.hasCompleteEventLog,
    error: Boolean(eventsError),
  })
  React.useEffect(() => {
    setDiceLuckLiveReady(diceLuckIsLive)
  }, [diceLuckIsLive])
  const freshDiceLuck = React.useMemo<{
    result: DiceLuckResult
  } | null>(() => {
    if (!gameStateForColors || !diceLuckDataState.shouldComputeFromEvents) return null
    // Fog of war: only the viewer's side while the game is live (the server
    // keeps only the side's hands, so they mark the side). Other players'
    // luck would come from the few battles the viewer saw.
    const fogSide = fogViewerSide(gameStateForColors, fogActiveGame)
    const playerIds = (game?.players ?? []).map((player) => String(player.slot)).filter((slot) => !fogSide || fogSide.has(slot))
    return {
      result: computeDiceLuck(fullEvents, gameStateForColors.map, playerIds),
    }
  }, [gameStateForColors, diceLuckDataState.shouldComputeFromEvents, game?.players, fullEvents, fogActiveGame])
  React.useEffect(() => {
    if (!id || !freshDiceLuck) return
    setRetainedDiceLuck({ gameId: id, ...freshDiceLuck })
  }, [freshDiceLuck, id])
  // Keep the last complete calculation visible while a delta fetch catches up
  // with new attack events. Never recompute from the incomplete cached prefix.
  const displayedDiceLuck = freshDiceLuck ?? retainedDiceLuckForGame
  const computedDiceLuck = displayedDiceLuck?.result ?? null
  const diceLuckLastRollAt = computedDiceLuck?.players.reduce((latest, player) => (
    Math.max(latest, player.seriesEvents.at(-1)?.ts ?? 0)
  ), 0) || null

  // Time-machine derived state — MUST live above the early returns
  // (Rules of Hooks). Keyed off gameStateForColors which is also
  // lifted, so both share the same loading-safe shape.
  const historicalGameState = React.useMemo(() => {
    if (historicalEventIndex === null) return null
    if (!gameStateForColors) return null
    // Only reconstruct once the fetched log actually reaches the requested
    // index. While loading (empty) or stale-behind (a short array after recent
    // turns), wait — replaying a short array would show an out-of-date board.
    // The refetch effect above pulls fresh events; this re-runs when they land.
    if (historicalEventIndex >= fullEvents.length) return null
    if (fogActiveGame) {
      // Fog: the server's view of the board at that moment, fog included.
      // On first open, stay live until it lands (one switch); between
      // snapshots, useFogSnapshot holds the previous one meanwhile.
      const snapshot = fogSnapshot.data
      if (!snapshot) return null
      return {
        ...gameStateForColors,
        events: fullEvents,
        map: { ...gameStateForColors.map, territories: applyFogSnapshot(gameStateForColors.map.territories, snapshot.territories) },
      }
    }
    const replayed = reconstructTerritoriesAt(
      gameStateForColors.initialTerritories,
      fullEvents,
      historicalEventIndex,
    )
    if (replayed.length === 0) return null
    const byId = new Map(replayed.map((t) => [t.id, t]))
    return {
      ...gameStateForColors,
      // Carry the FULL log so the snapshot sidebar + scrubber address events by
      // absolute index (offset 0), matching `historicalEventIndex`.
      events: fullEvents,
      map: {
        ...gameStateForColors.map,
        territories: gameStateForColors.map.territories.map((t) => {
          const r = byId.get(t.id)
          return r ? { ...t, ownerId: r.ownerId, armies: r.armies } : t
        }),
      },
    }
  }, [gameStateForColors, historicalEventIndex, fullEvents, fogActiveGame, fogSnapshot.data])

  // New incoming chat lines light up in the log (behind the text, 5 s, then
  // fade) the first time they render — live arrivals and anything unseen when
  // the game loads. Replaced the map-bar ticker.
  const freshChat = useFreshChatHighlights({
    gameId: id ?? '',
    messages,
    messagesReady,
    seenMessageId: persistedSeenId,
    viewerId: canOpenGameChat ? user?.id : undefined,
  })

  // ── Stable per-game helpers — ABOVE early returns (Rules of Hooks) ────────
  // slotByPlayerId and playerDisplayName are derived from game.players and
  // drilled into every phase UI. Without memoisation they are rebuilt as new
  // objects/functions on EVERY render (including the frequent GAME_STATE_PATCH
  // re-renders during bot turns), causing all phase-UI subtrees to reconcile
  // even when the player roster hasn't changed.
  //
  // Both live here — above the isLoading / !game early returns — to satisfy the
  // Rules of Hooks. The computations are cheap when game is null (empty object /
  // fast lookup miss), so the null-guard is just a belt-and-suspenders.
  const gamePlayers = game?.players ?? []
  const slotByPlayerIdMemo = React.useMemo<Record<string, number>>(() => {
    const m: Record<string, number> = {}
    for (const p of gamePlayers) {
      m[String(p.slot)] = p.slot
    }
    return m
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gamePlayers])

  // seat slot → chosen color slot, provided to the in-game render tree so map
  // fills, event flashes and logs honor each player's picked color (decoupled
  // from their seat). See lib/playerColor.
  const colorBySlotMemo = React.useMemo(
    () => buildColorBySlot(gamePlayers),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gamePlayers],
  )

  const playerDisplayName = React.useCallback(
    (playerId: string): string => {
      const p = gamePlayers.find((gp) => String(gp.slot) === playerId)
      return p?.displayName ?? `Player ${playerId}`
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gamePlayers],
  )

  // ── Auto-start "preparing the game" beat ──────────────────────────────────
  // When a LOBBY game flips to ACTIVE (auto-start filling the final seat via a
  // join or added bot, or a manual host start), players who were in the lobby
  // get a brief "preparing" overlay before the board is revealed. It masks the
  // client's state hydration and gives the transition a deliberate beat with a
  // minimum floor instead of snapping in — the server has already run placement
  // + randomized turn order before we observe ACTIVE, so this is a pure
  // client-side reveal delay. `preparingStart` latches on the transition;
  // `startMinDelayDone` flips true after the floor. The render derives the
  // actual overlay visibility from these + gameState readiness (below).
  const START_PREPARE_MS = 1800
  const [preparingStart, setPreparingStart] = React.useState(false)
  const [startMinDelayDone, setStartMinDelayDone] = React.useState(false)
  const prevStatusRef = React.useRef<string | undefined>(game?.status)
  const startTriggeredRef = React.useRef(false)
  const viewerIsMemberForStart = !!(
    user?.id && game?.players?.some((p) => p.userId === user.id)
  )
  // Begin the beat when we either watched LOBBY→ACTIVE here OR mounted straight
  // into a just-started ACTIVE game (auto-start from the Add Players screen
  // redirects here already-ACTIVE — see shouldBeginStartPrep). Latched once.
  React.useEffect(() => {
    const prev = prevStatusRef.current
    prevStatusRef.current = game?.status
    if (startTriggeredRef.current) return
    if (
      shouldBeginStartPrep({
        prevStatus: prev,
        status: game?.status,
        startedAt: game?.startedAt,
        isMember: viewerIsMemberForStart,
        now: Date.now(),
      })
    ) {
      startTriggeredRef.current = true
      setPreparingStart(true)
    }
  }, [game?.status, game?.startedAt, viewerIsMemberForStart])
  // Minimum-floor timer, independent of how the beat was triggered.
  React.useEffect(() => {
    if (!preparingStart) return
    setStartMinDelayDone(false)
    const t = setTimeout(() => setStartMinDelayDone(true), START_PREPARE_MS)
    return () => clearTimeout(t)
  }, [preparingStart])

  // First-entry coach mark: once per game per user, for a player in a live
  // game whose map has special rules (team games get none). It waits while a
  // blocking panel is up, in the snapshot view, or with the filter or ★ open.
  const coachViewer = game?.players.find((p) => p.userId === user?.id)
  const coachEntry = hydratedState && game
    ? rulesEntryPoints({ map: hydratedState.map, teams: hydratedState.teams, viewerId: coachViewer ? String(coachViewer.slot) : null, live: game.status === 'ACTIVE' && !inSnapshot })
    : { rules: false, players: false, team: false }
  // Each team game opens the team play rules by itself the first time this user
  // enters it (lib/teamRulesNotice). The ★ coach mark waits for it.
  const blockingPanelOpen = cardsModalOpen || chatOpen || rosterExpanded || diceLuckOpen
  const teamRulesNotice = useTeamRulesNotice({
    userId: user?.id,
    gameId: id,
    teamGame: coachEntry.team,
    eligible: !blockingPanelOpen && viewOverlay.overlay === null,
  })
  const firstEntry = useFirstEntryNotice({
    userId: user?.id,
    gameId: id,
    map: coachEntry.rules,
    eligible: coachEntry.rules && !blockingPanelOpen && viewOverlay.overlay === null && !teamRulesNotice.pending,
  })
  React.useEffect(() => {
    if (firstEntry.kind) setCoachShown((shown) => shown ?? firstEntry.kind)
  }, [firstEntry.kind])

  if (isLoading) {
    return (
      <View className="flex-1 bg-canvas items-center justify-center">
        <ActivityIndicator color="#94a3b8" />
        <Text className="text-ink-soft mt-2 font-typed">Loading…</Text>
      </View>
    )
  }

  // Only tear the screen down when there is NO usable game data. If a refetch
  // (or the socket) fails while we already hold a cached game, we keep the
  // board mounted and surface a non-blocking "Reconnecting…" banner instead
  // (see the banner below) — losing the live connection should not eject the
  // player from a game they're in the middle of.
  // Booted: an AI took over this viewer's seat after their time expired. Covers a
  // viewer who is live in the game (GAME_UPDATED) and one who comes back later
  // (GET → 403 AI_TAKEOVER). Replaces the whole game UI so nothing can be acted on.
  const timeExpired = takeoverNoticeForViewer(game, user?.id) ?? (game ? null : takeoverNoticeFromError(error))
  if (timeExpired) {
    return <TimeExpiredScreen notice={timeExpired} onBack={() => router.replace('/(app)')} />
  }

  if (!game) {
    const errorKind = classifyGameLoadError(error)
    // 403 → private game the viewer isn't invited to.
    const is403 = errorKind === 'forbidden'
    if (is403) {
      // Arrived via an invite URL (?code): we're auto-redeeming it — show a
      // spinner, not the PIN prompt, unless that auto-redeem has failed (then
      // fall through to let the viewer correct/enter a code manually).
      if (inviteCode && !autoRedeemFailed) {
        return (
          <SafeAreaView className="flex-1 bg-canvas items-center justify-center gap-4 px-6">
            <ActivityIndicator size="large" color="#ef4444" />
            <Text className="text-ink-soft font-typed text-sm">Joining game…</Text>
          </SafeAreaView>
        )
      }
      // The code was valid but the game can't be joined (full / already
      // started) — tell the viewer why instead of prompting for a code again.
      if (joinBlockedMessage) {
        return (
          <SafeAreaView className="flex-1 bg-canvas items-center justify-center gap-5 px-8">
            <Text style={{ fontSize: 44 }} accessibilityElementsHidden>
              🤦
            </Text>
            <Text className="text-ink text-lg font-stencil uppercase text-center">
              Sorry
            </Text>
            <Text className="text-ink-soft font-typed text-sm text-center">
              {joinBlockedMessage}
            </Text>
            <Button
              title="Back"
              variant="secondary"
              onPress={() => goBackOrHome(router)}
              accessibilityLabel="Go back"
            />
          </SafeAreaView>
        )
      }
      async function handleRedeemSubmit() {
        if (redeemPin.length !== 4) return
        setRedeemError(null)
        try {
          await redeemCode.mutateAsync({ code: redeemPin })
          // onSuccess drops the game into cache → query re-fires → this
          // early-return block exits and the screen renders State B.
          setCodeModalOpen(false)
          setRedeemPin('')
        } catch (err: unknown) {
          if (err instanceof HttpError) {
            if (err.status === 401) {
              setRedeemError('Invalid invite code. Check and try again.')
            } else if (err.status === 409) {
              setRedeemError(err.message || 'Cannot join this game right now.')
              setCodeModalOpen(false)
            } else if (err.status === 404) {
              setRedeemError('Game not found.')
            } else {
              setRedeemError(err.message || 'Something went wrong.')
            }
          } else {
            setRedeemError(err instanceof Error ? err.message : 'Something went wrong.')
          }
        }
      }

      return (
        <SafeAreaView className="flex-1 bg-canvas items-center justify-center gap-6 px-6">
          <Text className="text-ink text-lg font-stencil uppercase text-center">
            Private Game
          </Text>
          <Text className="text-ink-soft font-typed text-sm text-center">
            This game is private. Enter the 4-digit invite code to request access.
          </Text>
          {redeemError && (
            <Text className="text-blood font-typed text-sm text-center">{redeemError}</Text>
          )}
          <View className="w-full gap-3">
            <TextInput
              value={redeemPin}
              onChangeText={(v) => setRedeemPin(v.replace(/\D/g, '').slice(0, 4))}
              placeholder="0000"
              keyboardType="number-pad"
              maxLength={4}
              accessibilityLabel="4-digit invite code"
              className="bg-paper-up border border-olive rounded-xl px-4 py-3 text-ink font-stencil text-2xl text-center tracking-widest"
            />
            <Button
              title="Submit Code"
              onPress={handleRedeemSubmit}
              loading={redeemCode.isPending}
              disabled={redeemPin.length !== 4}
              accessibilityLabel="Submit invite code"
            />
          </View>
          <Button
            title="Go Back"
            variant="secondary"
            onPress={() => goBackOrHome(router)}
          />
        </SafeAreaView>
      )
    }

    // Network / timeout / 5xx — the game is probably fine, the phone just
    // can't reach the server. Never say "not found" here: tell the user to
    // check their connection and offer a retry that re-runs the query.
    if (errorKind === 'connection') {
      return (
        <View className="flex-1 bg-canvas items-center justify-center gap-4 px-6">
          <Text className="text-ink text-lg font-stencil uppercase text-center">
            Connection problem
          </Text>
          <Text className="text-ink-soft font-typed text-sm text-center">
            We couldn&apos;t reach the game. Check your network connection and try again.
          </Text>
          <Button title="Retry" onPress={() => refetchGame()} accessibilityLabel="Retry" />
          <Button title="Go Back" variant="secondary" onPress={() => goBackOrHome(router)} />
        </View>
      )
    }

    return (
      <View className="flex-1 bg-canvas items-center justify-center gap-4 px-6">
        <Text className="text-ink text-lg font-stencil uppercase">Game not found</Text>
        <Button title="Go Back" variant="secondary" onPress={() => goBackOrHome(router)} />
      </View>
    )
  }

  const myPlayer = game.players.find((p) => p.userId === user?.id)
  const isAdmin = game.adminId === user?.id

  // Reconnecting banner (decision computed above, in the hook cluster). We keep
  // the board fully interactive while the live connection re-establishes — turn
  // actions (place / attack / fortify / end) all go over HTTP and update the
  // cache directly, so they never depend on the socket. The socket only
  // delivers OTHER players'/bots' async moves, so a drop just means "live
  // opponent updates are paused", not "you're stuck".

  // Viewer-is-player flag drives the LOBBY two-state render.
  // Uses userId (from the full GameResponse) — more reliable than display name matching.
  const viewerIsPlayer = deriveViewerIsPlayer({ userId: user?.id, myPlayer })

  // ── Game state helpers ────────────────────────────────────────────────────
  // Use the hydrated state so phase UIs and the roster get map geometry.
  const gameState = hydratedState
  const inHistoricalView = historicalGameState !== null

  // isMyTurn must be derived from the ENGINE's turn pointer
  // (state.players[turnIndex] is the slot id of the current player), not
  // from game.players[game.currentPlayerIndex]. Those two arrays
  // are only aligned by convention; once a player is eliminated or the
  // API reorders the roster, the array index drifts away from the
  // engine's player list and action UIs leak through to the wrong
  // viewer. Same fix we applied to the roster panel in PR #122.
  const currentTurnPlayerId = deriveCurrentTurnPlayerId(gameState)
  const isMyTurn = deriveIsMyTurn({
    gameStatus: game.status,
    myPlayerSlot: myPlayer?.slot,
    gameState,
  })
  // Display-only handle on the current player (for "Waiting on X…" text
  // and the spectator panel). Lookup by slot id so it matches what
  // isMyTurn just computed.
  const currentPlayer =
    currentTurnPlayerId != null
      ? game.players.find((p) => String(p.slot) === currentTurnPlayerId) ?? null
      : null

  // playerDisplayName and slotByPlayerId are memoized above the early returns.
  // Alias slotByPlayerId to the memoized version for the rest of this scope.
  const slotByPlayerId = slotByPlayerIdMemo

  // My engine PlayerId = my slot as string.
  const myPlayerId = myPlayer ? String(myPlayer.slot) : null

  // ── Determine game winner ─────────────────────────────────────────────────
  const winnerPlayer: GamePlayerResponse | null = deriveWinnerFromHydratedState({
    gameStatus: game.status,
    gamePlayers: game.players,
    gameState,
    winnerSlot: game.resultSnapshot?.winnerSlot,
    winnerSlots: game.resultSnapshot?.winnerSlots,
  })
  // Team games: the winning team and every member, eliminated ones included.
  const winningTeam = deriveWinningTeam({
    gameStatus: game.status,
    gamePlayers: game.players,
    gameState,
    winnerTeam: game.resultSnapshot?.winnerTeam,
    winnerSlots: game.resultSnapshot?.winnerSlots,
  })

  // ── Event handlers ────────────────────────────────────────────────────────
  async function handleStart() {
    try {
      // Send NO config: mapId is locked at creation (game.mapId) and the
      // game config was persisted to setupConfig at creation/lobby-edit time.
      // performGameStart uses that saved setupConfig. Previously we sent a
      // hardcoded default config here, which OVERRODE the saved one — so e.g.
      // startingTroops always reset to 4 regardless of what was chosen.
      await startGame.mutateAsync({})
    } catch (err: unknown) {
      showToast(err instanceof Error ? err.message : 'Failed to start', 'error')
    }
  }

  // ── LOBBY State A: Leave Game ─────────────────────────────────────────────
  // Leave does NOT redirect — the LOBBY screen stays mounted and re-renders
  // into the visitor view ("Take this seat" on open seats). The obvious state change
  // (the player disappears from the joined list and the open seats offer Take this seat)
  // is confirmation enough; no toast for the success path.
  function handleDelete() {
    // Cross-platform confirm: open an inline Modal (rendered at the
    // overlay layer below). Alert.alert was the obvious choice but it
    // silently no-ops on Expo Web for destructive/cancel pairs (same
    // issue we hit with Leave).
    setDeleteConfirmOpen(true)
  }
  async function confirmDelete() {
    try {
      await deleteGame.mutateAsync()
      setDeleteConfirmOpen(false)
      router.replace('/(app)/games')
    } catch (err: unknown) {
      if (err instanceof HttpError) {
        if (err.status === 409) {
          showToast("Game already started — can't delete", 'error')
        } else if (err.status === 403) {
          showToast('Only the host can delete this game', 'error')
        } else {
          showToast(err.message || 'Could not delete game', 'error')
        }
      } else {
        showToast(err instanceof Error ? err.message : 'Could not delete game', 'error')
      }
      setDeleteConfirmOpen(false)
    }
  }

  async function handleLeave() {
    // No Alert.alert confirm — its destructive/cancel two-button layout
    // doesn't render reliably on Expo web (the user reported clicks
    // doing nothing), and the button itself is already labeled "Leave
    // Game" with destructive intent. If a tap was a mistake, the screen
    // flips immediately to the visitor view with Take this seat one tap away.
    try {
      await leaveGame.mutateAsync()
      // React Query invalidates the game detail → screen re-renders
      // into State B automatically. No navigation, no toast — the
      // visible state change IS the confirmation.
    } catch (err: unknown) {
      if (err instanceof HttpError) {
        if (err.status === 403) {
          showToast('The host must cancel the game', 'error')
        } else if (err.status === 400) {
          showToast("Game already started — can't leave", 'error')
        } else if (err.status === 404) {
          showToast('You are not in this game', 'error')
        } else {
          showToast(err.message || 'Could not leave game', 'error')
        }
      } else {
        showToast(err instanceof Error ? err.message : 'Could not leave game', 'error')
      }
    }
  }

  // ── LOBBY: take a seat ───────────────────────────────────────────────────
  // "Take this seat" (a visitor picks an open seat) and the invitee's "Join
  // game" (slot undefined → the server seats them in their saved seat). The
  // viewer's default colour goes with it, so joining needs no colour picker;
  // they can change it afterwards from their seat's Color action.
  async function handleTakeSeat(slot: number | undefined) {
    if (!game || takeSeatPending) return
    setTakeSeatPending({ slot })
    try {
      const req = takeSeatJoinRequest(game.id, slot, game.players, user?.preferredColorSlot)
      await takeSeat.mutateAsync({ ...req, isPublic: game.isPublic, code: inviteCode ?? undefined })
    } catch (err: unknown) {
      showToast(takeSeatErrorMessage(err), 'error')
      void refetchGame()
    } finally {
      setTakeSeatPending(null)
    }
  }

  // Color picker handler — closes the modal on success, shows a toast on
  // failure. Lives here so it can access updateMyColor, showToast, and
  // setColorPickerOpen without threading all three into LobbyView.
  async function handleUpdateMyColor(color: number) {
    try {
      await updateMyColor.mutateAsync({ color })
      setColorPickerOpen(false)
    } catch (err: unknown) {
      if (err instanceof HttpError && err.status === 409) {
        showToast('That color was just taken — try another', 'error')
      } else {
        showToast(err instanceof Error ? err.message : 'Could not change color', 'error')
      }
    }
  }

  // Persistent header only on LOBBY (and COMPLETE for screen-reader
  // context). During ACTIVE play the user wants the map to fill the
  // viewport — back / menu stay in the top bar and chat lives beside the
  // map controls instead. See the overlay block below.
  const showPersistentHeader = game.status === 'LOBBY'

  // Roster strip — only shown during ACTIVE play (hidden during
  // LOBBY/COMPLETE per existing rules). In BOTH orientations the roster is now
  // a HORIZONTAL row inside a header, not a right-edge vertical strip:
  //   • Landscape: horizontal row inside `landscapeActionHeader` (the action
  //     panel), so the map fills flush to the right edge (no right gutter).
  //   • Portrait: horizontal row in the top header bar above the map, to the
  //     left of the cog. Map flexes to the remaining vertical space below.
  // The player roster is now the compact PlayerDotsStrip inside GameTopBar
  // (see the portrait top bar + landscapeActionHeader below). MapView always
  // receives null for rightOverlay so the map edge is clean.
  const mapRightOverlay = null

  // Shared handlers for the thin top bar (portrait + landscape variants).
  const topBarCanResign =
    game.status === 'ACTIVE' &&
    !!myPlayer &&
    !(gameState?.eliminated ?? []).includes(String(myPlayer.slot))
  // The full log is the grown log sheet (GameLogSheet), opened by the chat
  // bar's grow toggle and a finished game's top-bar log button.
  const toggleActivity = () => setLogGrown((grown) => !grown)
  const showActivity = game.status !== 'COMPLETE' || shouldShowCompletedActivity(gameState)

  // Map controls bar — zoom (always on: reset / + / −) + the region-bonus view
  // toggle. Rendered directly BENEATH the map in every view (all active phases,
  // spectator, region-details), replacing the old floating corner chips.
  const zoomBy = (dir: 1 | -1) => {
    const vb = gameState?.map.viewBox
    if (!vb) return
    const next = clampZoomScale(zoomScale + dir * ZOOM_STEP)
    if (next === zoomScale) return
    setPanOffset(
      rescaleAboutCenter(vb.x ?? 0, vb.y ?? 0, vb.width, vb.height, zoomScale, next, panOffset),
    )
    setZoomScale(next)
  }
  const resetZoom = () => {
    const vb = gameState?.map.viewBox
    if (!vb) return
    setZoomScale(MIN_ZOOM_SCALE)
    setPanOffset(initialPanForFocus(vb.x ?? 0, vb.y ?? 0, vb.width, vb.height, MIN_ZOOM_SCALE))
    // Regions view: close (collapse the focused region / clear selection) then
    // send the list back to the top (the resetSignal effect runs post-collapse).
    setFocusedRegionId(null)
    setFocusedDetailTerritoryId(null)
    setRegionDetailsResetSignal((n) => n + 1)
  }
  const showToolbarCards = game.status === 'ACTIVE' &&
    !canTurnInCardsNow({ gameStatus: game.status, gameState, isMyTurn })
  // Your turn: log on/off. Turning it off also leaves any snapshot opened
  // from it, straight back to the live turn controls.
  // Phones, your turn: ONE button opens log + chat together (chat input over
  // the log; the input's chat button narrows it to chat only) and closes back
  // to the turn controls.
  const toggleLogChat = () => {
    if (chatOpen) closeChat()
    if (turnPanel === 'controls') {
      // Opened from the unread badge: straight to the chat-only log, where the
      // unseen lines play their highlight.
      if (unreadCount > 0 && !logChatOnly) {
        setLogChatOnly(true)
        setChatOnlyFromBadge('mine')
      }
      // The badge clears on the tap; the lines still play their highlight.
      if (unreadCount > 0) markSeen()
      setTurnPanel('chat')
      return
    }
    Keyboard.dismiss()
    setHistoricalEventIndex(null)
    setTurnPanel('controls')
  }
  // Phones, off-turn: show/hide the chat bar over the log (remembered).
  // Opened from the unread badge: straight to chat only, the badge cleared.
  const toggleOffTurnChatBar = () => {
    if (!inlineChatOn && unreadCount > 0) {
      if (!logChatOnly) {
        setLogChatOnly(true)
        setChatOnlyFromBadge('theirs')
      }
      markSeen()
    }
    setInlineChatOpen(!inlineChatOn)
  }
  const toggleTurnLog = () => {
    if (chatOpen) closeChat()
    Keyboard.dismiss()
    if (turnPanel === 'log') {
      setHistoricalEventIndex(null)
      setTurnPanel('controls')
    } else {
      setTurnPanel('log')
    }
  }
  // Desktop/tablet, off-turn: the cards button lives in the chat row (right of
  // the log filter) instead of the map bar.
  const chatRowCards = persistentChatLog && !isMyTurn
  const chatRowCardsButton = chatRowCards && showToolbarCards && myPlayerId && gameState ? (
    <CardHudButton
      compact
      compactSize={30}
      handCount={(gameState.cards?.[myPlayerId] ?? []).length}
      canTurnIn={false}
      mustTurnIn={false}
      onPress={openCardsModal}
    />
  ) : null
  // The log controls (ALL | CHAT, filters, grow) and, when open, the filter
  // chips. Portrait puts them on the chat input's line (the pill left, filters
  // and grow right of send) with the chips beneath; the wide layouts keep a
  // row above the input. Open filters stand in for the input (in CHAT they're
  // players and sort: chat lines have no event kind).
  // Shared by the in-place chat bar and the grown sheet's, so both drive the
  // same log state.
  const logControlProps: GameLogControlsProps = {
    view: chatOnlyActive ? 'chat' : 'all',
    canChatOnly: hasChatMessages,
    onViewChange: (next) => {
      setChatOnlyFromBadge(false)
      setLogChatOnly(next === 'chat')
      // The badge clears on the tap; the lines still play their highlight.
      if (next === 'chat' && unreadCount > 0) markSeen()
    },
    unreadCount,
    filtersOpen: logFiltersOpen,
    onFiltersOpenChange: setLogFiltersOpen,
    filtersActive: hasActiveFilters(logFilters),
    grown: logGrown,
    // Wide layouts off-turn: the log already fills the side column, so no grow.
    onGrownChange: persistentChatLog && !isMyTurn ? undefined : setLogGrown,
  }
  const logFiltersShown = logFiltersOpen
  const logFilterPanel = logFiltersShown ? (
    <GameLogFilterPanel players={chatOnlyActive ? chatAuthors : game.players} filters={logFilters} onChange={setLogFilters} kinds={chatOnlyActive ? [] : logFilterKinds} />
  ) : null
  // Chips closed with filters on: a thin tinted line names them (CHAT: only
  // what applies to chat, so no kind).
  const logFiltersApplied = chatOnlyActive ? { ...logFilters, kindFilter: null } : logFilters
  const logFilterSummary = logFiltersShown || !hasActiveFilters(logFiltersApplied) ? null : (
    <GameLogFilterSummary
      players={game.players}
      filters={logFilters}
      chatOnly={chatOnlyActive}
      onOpen={() => setLogFiltersOpen(true)}
      onClear={() => setLogFilters(DEFAULT_LOG_FILTERS)}
    />
  )
  const logControlParts = gameLogControlParts(logControlProps)
  const chatBarLogProps = !isLandscape
    ? {
      leading: logControlParts.viewToggle,
      trailing: <View style={{ flexDirection: 'row', gap: 8 }}>{logControlParts.filtersToggle}{logControlParts.growToggle}</View>,
      below: logFilterPanel,
      topStrip: logFilterSummary,
      inputHidden: logFiltersShown,
    }
    : {
      above: <><GameLogControls {...logControlProps} trailing={chatRowCardsButton} />{logFilterPanel ? <View style={{ marginBottom: 6 }}>{logFilterPanel}</View> : null}</>,
      bottomStrip: logFilterSummary,
      inputHidden: logFiltersShown,
    }

  // The inline chat bar (input + log controls). Shared by the live view and the
  // finished-game view, so the end of a game gets the same chat and the same
  // grow/shrink log control. Grown in a sheet (not the wide layouts' column),
  // the sheet carries the bar instead: one input owns the draft.
  const inlineChatBar = inlineChatOn && !(logGrown && !persistentChatLog) ? (
    <GameChatInputBar
      gameId={id ?? ''}
      expandOnFocus={!isLandscape}
      onFocusChange={setInlineChatInputFocused}
      roomy={persistentChatLog}
      bottomRule={isLandscape}
      {...chatBarLogProps}
    />
  ) : undefined
  // The chat-only list behind the bar's CHAT view. Shared by both views too.
  const renderChatOnlyLog = inlineChatOn && chatOnlyActive && gameState
    ? ({ orientation, topContent }: { orientation: 'bottom-panel' | 'left-sidebar'; topContent?: React.ReactNode }) => (
      <ChatLogList
        messages={messages}
        state={gameState}
        players={game.players}
        orientation={orientation}
        topContent={topContent}
        filters={logFilters}
      />
    ) : undefined

  // Live game only: ★ on maps with a rules overlay, the Players filter in
  // every game, and "Team play rules" in the game menu for a player on a team.
  const rulesEntry = gameState
    ? rulesEntryPoints({ map: gameState.map, teams: gameState.teams, viewerId: myPlayerId, live: game.status === 'ACTIVE' && !inSnapshot })
    : { rules: false, players: false, team: false }
  const shownOverlay = viewOverlay.overlay === 'map' && rulesEntry.rules ? 'map'
    : viewOverlay.overlay === 'players' && rulesEntry.players ? 'players' : null
  // The view group is one segmented control (lib/mapViewGroup). Every tap
  // goes through tapViewGroup, so leaving the players filter always clears it.
  // (Not hooks: these run after the screen's early returns.)
  const viewGroup: ViewGroupState = { mode: regionDetailsMode ? 'regions' : 'game', overlay: shownOverlay, filter: shownOverlay === 'players' ? viewOverlay.filter : [] }
  // Opening ★ closes the chat (the drawer, and on phones the inline chat bar
  // the docked legend sheet would sit over; maintainer, 2026-11-03).
  const closeChatForRules = () => {
    if (chatOpen) closeChat()
    if (!isDesktop && inlineChatOn) setInlineChatOpen(false)
  }
  const applyViewGroup = (next: ViewGroupState) => {
    // Leaving the filter bar keeps its selection for next time; opening it
    // restores that selection (chips that no longer exist drop out).
    if (viewGroup.overlay === 'players' && next.overlay !== 'players') {
      setLastPlayerFilter(viewGroup.filter)
      if (lastFilterKey) setItem(lastFilterKey, viewGroup.filter.join(',')).catch((error) => reportError(error, { tags: { surface: 'player-filter', action: 'write' } }))
    }
    if (viewGroup.overlay !== 'players' && next.overlay === 'players' && next.filter.length === 0) {
      const keys = new Set((gameState ? playerFilterOptions({ players: gameState.players, teams: gameState.teams, eliminated: gameState.eliminated, colorOf: () => '', nameOf: (p) => p }) : []).map((o) => o.key))
      next = { ...next, filter: lastPlayerFilter.filter((k) => keys.has(k)) }
    }
    if (next.overlay === 'map' && viewGroup.overlay !== 'map') closeChatForRules()
    setViewOverlay({ overlay: next.overlay, filter: next.filter })
    if (next.mode === viewGroup.mode) return
    setRegionDetailsMode(next.mode === 'regions')
    setFocusedRegionId(null)
    setFocusedDetailTerritoryId(null)
  }
  const closeRulesOverlay = () => applyViewGroup(tapViewGroup(viewGroup, 'map'))
  const colorOfPlayer = (pid: string) => PLAYER_COLORS[clampPlayerSlot(colorBySlotMemo[Number(pid)] ?? Number(pid))].hex
  const playersByTeam = !!gameState?.teams && Object.keys(gameState.teams).length > 0
  const playerFilter = gameState && shownOverlay === 'players'
    ? playerFilterOptions({ players: gameState.players, teams: gameState.teams, eliminated: gameState.eliminated, colorOf: colorOfPlayer, nameOf: playerDisplayName })
    : []
  // The players filter: the selection's visible land brought forward on the
  // map, the rest darkened (null while nothing is selected).
  const focusTerritoryIds = gameState && shownOverlay === 'players'
    ? filteredTerritoryIds(gameState.map.territories, playerFilter, viewGroup.filter)
    : null
  const rulesOverlayPalette = overlayPalette(theme)
  const rulesOverlayModel = gameState && shownOverlay === 'map'
    ? buildMapRulesModel(gameState.map, rulesOverlayPalette, { compact: !isDesktop })
    : null
  // The game menu's "Team play rules" (team games, a player on a team).
  const teamRules = gameState && rulesEntry.team && myPlayerId
    ? buildTeamRulesInfo({
      map: gameState.map,
      teams: gameState.teams,
      players: gameState.players,
      viewerId: myPlayerId,
      colorOf: colorOfPlayer,
      nameOf: playerDisplayName,
    }, rulesOverlayPalette)
    : null
  const mapControlsBar = gameState ? (
    <MapControlsBar
      // Portrait with the chat input right beneath: a lighter divider between.
      bottomRuleColor={!isLandscape && inlineChatOn ? (theme === 'dark' ? 'rgba(138, 161, 74, 0.35)' : 'rgba(74, 90, 42, 0.3)') : undefined}
      compact={!isDesktop && (showToolbarCards || isMyTurn || (canOpenGameChat && winWidth < 420))}
      // No chat in the snapshot (time-machine) view; desktop toggles chat
      // from the top bar instead (desktopChatToggle).
      // Left (phones): chat, then on your turn the log toggle. Chat, log or
      // neither — exclusive (off-turn the log is already the default view).
      // Off-turn (portrait, live game) the same button shows or hides the chat
      // bar above the log (remembered per device); the log itself always
      // shows. Landscape phones have no chat bar and a finished game opens
      // the conversation drawer instead, so neither gets it. Unread
      // badges it; a tap then opens the chat bar on chat only. When your turn
      // starts it reads your turn's state (the turn controls by default).
      leftAccessory={canOpenGameChat && !inSnapshot && !isDesktop && !persistentChatLog &&
        (isMyTurn || (game.status === 'ACTIVE' && !chatInputDisabled)) ? (controlSize) => (isMyTurn ? (
        <MapChatToggle
          glyph="log-chat"
          controlSize={controlSize}
          unreadCount={unreadCount}
          active={turnPanel !== 'controls'}
          onToggle={toggleLogChat}
          labels={{
            on: 'Close log and chat',
            off: unreadCount > 0 ? `Open log and chat (${unreadCount} unread)` : 'Open log and chat',
          }}
        />
      ) : (
        <MapChatToggle
          glyph="log-chat"
          controlSize={controlSize}
          unreadCount={unreadCount}
          active={inlineChatOn}
          onToggle={toggleOffTurnChatBar}
          labels={{
            on: 'Hide the chat bar',
            off: unreadCount > 0 ? `Show the chat bar (${unreadCount} unread)` : 'Show the chat bar',
          }}
        />
      )) : undefined}
      // Right: the cards button.
      // (Desktop/tablet off-turn: it sits in the top bar next to the menu.)
      rightAccessory={showToolbarCards && myPlayerId && !chatRowCards ? (controlSize) => (
        <CardHudButton
          compact
          compactSize={controlSize}
          handCount={(gameState.cards?.[myPlayerId] ?? []).length}
          canTurnIn={false}
          mustTurnIn={false}
          onPress={openCardsModal}
        />
      ) : undefined}
      onReset={resetZoom}
      onZoomIn={() => zoomBy(1)}
      onZoomOut={() => zoomBy(-1)}
      canZoomIn={zoomScale < MAX_ZOOM_SCALE - 1e-6}
      canZoomOut={zoomScale > MIN_ZOOM_SCALE + 1e-6}
      rulesAnchorRef={rulesAnchorRef}
      onTogglePlayers={rulesEntry.players ? () => applyViewGroup(tapViewGroup(viewGroup, 'players')) : undefined}
      playersOpen={shownOverlay === 'players'}
      playersByTeam={playersByTeam}
      onToggleRules={rulesEntry.rules ? () => applyViewGroup(tapViewGroup(viewGroup, 'map')) : undefined}
      rulesOpen={shownOverlay === 'map'}
      mode={viewGroup.mode}
      // Game / Regions also close the players filter or the ★ overlay.
      onModeChange={(m) => applyViewGroup(tapViewGroup(viewGroup, m))}
      belowBar={shownOverlay === 'players' ? (
        <PlayerFilterBar
          options={playerFilter}
          selected={viewGroup.filter}
          team={playersByTeam}
          onToggle={(key) => applyViewGroup(toggleViewGroupFilter(viewGroup, key))}
        />
      ) : undefined}
    />
  ) : null

  // Landscape action-panel header — a single row pinned at the very
  // top of the left action column (or, when spectating, the activity
  // sidebar). Contains the cog + horizontal player roster strip. Lives
  // INSIDE the action column so it inherits the column's safe-area
  // padding, removing every iPhone Dynamic Island / notch interaction
  // bug that the previous floating-cog-over-the-map approach kept
  // surfacing across landscape-LEFT / landscape-RIGHT rotation modes.
  // Always rendered when game is ACTIVE or COMPLETE in landscape — on
  // your turn it caps the phase HUD; on your opponent's turn it caps
  // the RecentActivitySidebar. Portrait keeps its existing top header
  // bar (rendered earlier) so this constant is null there.
  // Hidden in the snapshot view on every device: the snapshot covers the full
  // screen (maintainer, 2026-10-07).
  // Landscape variant of the thin top bar. Lives INSIDE the action column
  // (threaded into the phase UIs / spectator sidebar as `actionPanelHeader`)
  // so it inherits the column's safe-area padding — no floating-over-the-map
  // notch bugs. Minimal left / right padding hugs the safe-area boundary.
  // Desktop: the same chat / log toggles the phone map bar uses, as compact
  // squares in the top bar right after the menu button (desktop's map bar has
  // none). Off-turn the chat input is always open and the log is the default,
  // so they show on your turn (chat / log / neither) and in a completed game
  // (chat → drawer).
  const desktopToggles = isDesktop && canOpenGameChat && !inSnapshot && !persistentChatLog &&
    (isMyTurn || game.status !== 'ACTIVE') ? (
      <View testID="desktop-chat-log-toggles" style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
        <MapChatToggle
          square
          controlSize={30}
          unreadCount={unreadCount}
          active={chatOpen || inlineChatOn}
          onToggle={() => selectChatSide(!(chatOpen || inlineChatOn))}
        />
        {isMyTurn ? (
          <MapLogToggle square controlSize={30} active={turnPanel === 'log'} onToggle={toggleTurnLog} />
        ) : null}
      </View>
    ) : null
  // Props every game top bar instance shares (portrait, landscape column, wide).
  const gameTopBarProps = (status: 'ACTIVE' | 'COMPLETE') => ({
    connectionNotice: connectionBanner ?? undefined,
    gameId: id ?? '',
    status,
    state: gameState,
    players: game.players,
    bootableAt: game.bootableAt,
    bootAfterSeconds: game.bootAfterSeconds,
    viewerUserId: user?.id,
    presence,
    canResign: topBarCanResign,
    tutorialEnabled,
    onTutorialEnabledChange: setTutorialEnabled,
    onShowDiceLuck: showDiceLuckEntry ? () => openDiceLuck() : undefined,
    teamRules,
    onShowResults: showResults,
    dmUnreadTotal,
    // A finished game's chat bar carries the log's grow toggle, so the top-bar
    // log button only remains where there is no bar (spectators, landscape phones).
    showActivity: showActivity && !(game.status === 'COMPLETE' && inlineChatOn),
    activityOpen: logGrown,
    playersActive: rosterExpanded,
    onOpenPlayers: toggleRoster,
    onToggleActivity: toggleActivity,
    onBack: () => goBackOrHome(router),
  })
  const landscapeTopBar =
    isLandscape &&
    (game.status === 'ACTIVE' || game.status === 'COMPLETE') &&
    !inHistoricalView ? (
      <GameTopBar
        {...gameTopBarProps(game.status)}
        leadingControls={desktopToggles}
        playersAlignRight
        testIDSuffix="-landscape"
      />
    ) : null
  const landscapeActionHeader = landscapeTopBar

  // ── Region-details overlay handlers ────────────────────────────────────
  // handleDetailRegionPress + handleDetailTerritoryPress moved above
  // the early-return blocks to satisfy Rules of Hooks (see the comment
  // by their useCallback declarations earlier in the function body).
  const detailAdjacentIds =
    regionDetailsMode && focusedDetailTerritoryId && gameState
      ? gameState.map.territories.find((t) => t.id === focusedDetailTerritoryId)
          ?.adjacencies ?? []
      : []

  // ── Top-level view selection ────────────────────────────────────────────
  const topLevelView = selectTopLevelView({
    isLoading: false, // already returned above if isLoading
    game,
    gameState,
    myPlayerId,
    error,
  })

  // Show the "preparing the game" overlay while the start beat is in progress:
  // the minimum floor hasn't elapsed yet, OR the game state isn't hydrated. The
  // board mounts underneath and hydrates during this window. `preparingStart`
  // is latched, so once the floor passes AND gameState is ready this is false
  // and stays false.
  const showStartingOverlay = preparingStart && (!startMinDelayDone || !gameState)

  // ── Active phase view selection ─────────────────────────────────────────
  const activePhaseView = selectActivePhaseView({
    regionDetailsMode,
    isMyTurn,
    phase: gameState?.phase ?? '',
  })

  // The map only bleeds into part of the header. Fill the remaining header
  // and safe area with its paper background so there is no canvas-colour seam.
  const portraitMapOverlap = !isLandscape &&
    (game.status === 'ACTIVE' || game.status === 'COMPLETE') &&
    !!gameState && mapGameLayout(gameState.map).topBarOverlap > 0
  // A map whose backdrop covers the top bar (MapDef.backdropColor.topBar) also
  // fills the safe area and header strip above the map with it.
  const mapBackdrop = (game.status === 'ACTIVE' || game.status === 'COMPLETE') && gameState?.map.backdropColor?.topBar
    ? gameState.map.backdropColor[theme === 'dark' ? 'dark' : 'light']
    : undefined

  return (
    <PlayerColorProvider colorBySlot={colorBySlotMemo}>
    <ChatRowActionsProvider gameId={id ?? ''} currentUserId={user?.id} fresh={freshChat} onChatRowsSeen={onChatRowsSeen}>
    <GameOverlayTopContext.Provider value={
      game.status === 'LOBBY'
        ? Math.max(navBarBottomY ?? 0, screenInsets.top + GAME_TOP_BAR_HEIGHT)
        : gameState && (game.status === 'ACTIVE' || game.status === 'COMPLETE')
        ? Math.max(navBarBottomY ?? 0, screenInsets.top + (isLandscape ? GAME_TOP_BAR_HEIGHT : PORTRAIT_GAME_TOP_BAR_HEIGHT))
        : 0
    }>
    <MapChromeProvider height={portraitTopBarHeight}>
    <InitialGameReveal>
    <SafeAreaView testID="game-screen" className={`flex-1 ${portraitMapOverlap ? 'bg-paper' : 'bg-canvas'}`}
      style={portraitMapOverlap && mapBackdrop ? { backgroundColor: mapBackdrop } : undefined}
      edges={SAFE_AREA_EDGES_BELOW_FILL}>
      {/* Status-bar strip matches the paper GameTopBar (ACTIVE/COMPLETE); the
          lobby's transparent header sits on canvas, so its strip does too. */}
      <TopInsetFill className={game.status === 'ACTIVE' || game.status === 'COMPLETE' ? 'bg-paper' : 'bg-canvas'} color={mapBackdrop} />
      {/* Views without a game controls bar keep the notice in safe-area flow.
          ACTIVE/COMPLETE controls own their notice inside GameTopBar (the
          snapshot view has no top bar, so it keeps this one). */}
      {connectionBanner && (showPersistentHeader || inHistoricalView) && (
        <GameBanner
          message={connectionBanner}
          tone="info"
          spinner
          topInset={0}
          inline
        />
      )}
      {/* ── Navigation header (LOBBY only) ──────────────────────────────── */}
      {/* Stripped to: back-nav (left) + centred game name. No logo, no chat
          bubble, no cog, no status pill — those clutter a simple waiting room. */}
      {showPersistentHeader && (
        <View
          onLayout={({ nativeEvent: { layout } }) => setNavBarBottomY(layout.y + layout.height)}
          className="flex-row items-center px-4 border-b border-olive"
          style={{ height: GAME_TOP_BAR_HEIGHT }}
        >
          <TouchableOpacity
            onPress={() => goBackOrHome(router)}
            className="p-1 mr-2"
            accessibilityLabel="Go back"
            accessibilityRole="button"
          >
            <Text className="text-blood text-base font-typed">← Back</Text>
          </TouchableOpacity>
          <Text
            className="text-ink font-stencil text-lg uppercase flex-1 text-center"
            numberOfLines={1}
          >
            {game.name}
          </Text>
          {/* Spacer keeps title visually centred against the back button */}
          <View style={{ width: 48 }} />
        </View>
      )}

      {/* ── Portrait top bar (ACTIVE/COMPLETE only) ───────────────────────
          The thin GameTopBar: [ ☰ menu …spacer… player dots ]. Landscape
          renders the same bar inside the action column (landscapeActionHeader
          above), so this portrait instance is gated to !isLandscape. */}
      {!isLandscape &&
        (game.status === 'ACTIVE' || game.status === 'COMPLETE') &&
        gameState &&
        !inHistoricalView && (
          <View pointerEvents="box-none" style={{ zIndex: 10 }} onLayout={({ nativeEvent: { layout } }) => {
            setNavBarBottomY(layout.y + layout.height)
            setPortraitTopBarHeight(layout.height)
          }}>
            <GameTopBar
              {...gameTopBarProps(game.status)}
              leadingControls={desktopToggles}
              style={{ height: PORTRAIT_GAME_TOP_BAR_HEIGHT, paddingTop: PORTRAIT_GAME_TOP_BAR_PAD }}
              overMap={portraitMapOverlap}
              testIDSuffix="-portrait"
            />
          </View>
        )}

      {/* ACTIVE / COMPLETE (landscape): floating overlays + player
          roster live as absolute-positioned siblings of the main
          content. Defined in the absolute overlay block at the bottom
          of this component. */}

      {/* ── Main content area: top-level branch ─────────────────────────── */}
      {topLevelView === 'active-player-turn' && gameState && myPlayerId ? (
        <ActiveGameView
          game={game}
          gameState={gameState}
          myPlayer={myPlayer}
          myPlayerId={myPlayerId}
          isMyTurn={isMyTurn}
          slotByPlayerId={slotByPlayerId}
          playerDisplayName={playerDisplayName}
          activePhaseView={activePhaseView}
          placementStack={placementStack}
          onPlacementStackChange={setPlacementStack}
          placementStepMode={placementStepMode}
          onPlacementStepModeChange={setPlacementStepMode}
          isLandscape={isLandscape}
          isDesktop={isDesktop}
          historicalGameState={historicalGameState}
          historicalEventIndex={historicalEventIndex}
          inHistoricalView={inHistoricalView}
          onScrubEvent={toggleHistoricalEvent}
          onReturnToLive={() => setHistoricalEventIndex(null)}
          snapshotArrowKeysEnabled={snapshotArrowKeysEnabled}
          // Grown (wide layouts): an event shrinks the log as it opens the snapshot.
          onViewAtEvent={(index) => {
            setLogGrown(false)
            toggleHistoricalEvent(index)
          }}
          dockKeyboardTop={inlineChatDockTop}
          // Grown in a sheet (not the wide layouts' column), the sheet carries
          // the chat bar: one input owns the draft.
          chatBar={inlineChatBar}
          // Hidden chat bar (off-turn): its filters (and their summary) are
          // out of sight, so the log shows whole.
          logFilters={inlineChatOn ? logFilters : DEFAULT_LOG_FILTERS}
          logGrown={persistentChatLog && logGrown}
          // Your turn's log + chat view shows the full log unless narrowed.
          // (Landscape phones have no input or chat-only filter: always the full log.)
          turnLogOpen={isMyTurn && (turnPanel === 'log' || (turnPanel === 'chat' && (!chatOnlyActive || chatInputDisabled)))}
          onTurnMapPress={isMyTurn && turnPanel !== 'controls' ? () => {
            Keyboard.dismiss()
            setHistoricalEventIndex(null)
            setTurnPanel('controls')
          } : undefined}
          persistentChatLog={persistentChatLog}
          mapTopReserve={persistentChatLog ? GAME_TOP_BAR_HEIGHT : 0}
          chatOnlyLog={inlineChatOn && chatOnlyActive}
          // The chat-only list behind the input's chat filter (your turn on
          // phones; the wide layouts' persistent log).
          renderTurnChatLog={renderChatOnlyLog}
          regionDetailsMode={regionDetailsMode}
          focusedRegionId={focusedRegionId}
          focusedDetailTerritoryId={focusedDetailTerritoryId}
          detailAdjacentIds={detailAdjacentIds}
          regionColorById={regionColorById}
          onDetailRegionPress={handleDetailRegionPress}
          onDetailTerritoryPress={handleDetailTerritoryPress}
          onDetailBackgroundPress={handleDetailBackgroundPress}
          regionDetailsResetSignal={regionDetailsResetSignal}
          regionToggleNode={null}
          regionToggleCorner="bottom-right"
          zoomToggleNode={null}
          zoomToggleCorner="bottom-right"
          mapControlsBar={mapControlsBar}
          rulesOverlay={rulesOverlayModel ? { model: rulesOverlayModel, onClose: closeRulesOverlay } : null}
          focusTerritoryIds={focusTerritoryIds}
          zoomEnabled={zoomEnabled}
          zoomScale={zoomScale}
          panOffset={panOffset}
          onPanChange={setPanOffset}
          onZoomScaleChange={handleZoomScaleChange}
          landscapeActionHeader={landscapeActionHeader}
          onOpenCardsModal={openCardsModal}
          viewerJoinedAt={wsConnectedAt.current}
          mapRightOverlay={mapRightOverlay}
          viewerUserId={user?.id}
          onBootPlayer={(userId, name) => { setBootError(null); setBootTarget({ userId, name }) }}
          tutorialEnabled={tutorialEnabled}
          onTutorialEnabledChange={setTutorialEnabled}
        />
      ) : topLevelView === 'complete' && gameState ? (
        <CompleteView
          game={game}
          gameState={gameState}
          myPlayer={myPlayer}
          isLandscape={isLandscape}
          isDesktop={isDesktop}
          inHistoricalView={inHistoricalView}
          historicalGameState={historicalGameState}
          historicalEventIndex={historicalEventIndex}
          onViewAtEvent={toggleHistoricalEvent}
          onScrubEvent={toggleHistoricalEvent}
          onReturnToLive={() => setHistoricalEventIndex(null)}
          snapshotArrowKeysEnabled={snapshotArrowKeysEnabled}
          chatBar={inlineChatBar}
          logFilters={inlineChatOn ? logFilters : DEFAULT_LOG_FILTERS}
          renderChatOnlyLog={renderChatOnlyLog}
          regionToggleNode={null}
          regionToggleCorner="bottom-right"
          zoomToggleNode={null}
          zoomToggleCorner="bottom-right"
          mapControlsBar={mapControlsBar}
          regionDetailsMode={regionDetailsMode}
          focusedRegionId={focusedRegionId}
          regionColorById={regionColorById}
          zoomEnabled={zoomEnabled}
          zoomScale={zoomScale}
          panOffset={panOffset}
          onPanChange={setPanOffset}
          onZoomScaleChange={handleZoomScaleChange}
          landscapeActionHeader={landscapeActionHeader}
          viewerJoinedAt={wsConnectedAt.current}
        />
      ) : topLevelView === 'active-loading-spinner' ? (
        // Game has STARTED (ACTIVE/COMPLETE/etc.) but a derived value
        // (gameState, myPlayerId, etc.) isn't ready yet on this render
        // — usually for one frame after returning from a sibling
        // screen (chat, players, log) while react-query repopulates
        // the cache. We MUST NOT fall through to the LOBBY render in
        // that window: it briefly flashes the joined-list / setup CTAs
        // over an active game, which the host called out as the "brief
        // flicker of the lobby UX" bug. Show a spinner instead until
        // the active branch above can render.
        <SafeAreaView className="flex-1 bg-canvas items-center justify-center">
          <ActivityIndicator color="#ef4444" />
        </SafeAreaView>
      ) : (
        // topLevelView === 'lobby' (or any other — should not happen given
        // the early returns above handle isLoading + !game + forbidden + connection + notfound)
        <LobbyView
          game={game}
          myPlayer={myPlayer}
          viewerId={user?.id}
          viewerIsPlayer={viewerIsPlayer}
          isAdmin={isAdmin}
          mapDisplayName={mapDisplayName}
          onTakeSeat={(slot) => void handleTakeSeat(slot)}
          takeSeatPending={takeSeatPending}
          onLeave={handleLeave}
          leaveIsPending={leaveGame.isPending}
          onDelete={handleDelete}
          deleteIsPending={deleteGame.isPending}
          onStart={handleStart}
          startIsPending={startGame.isPending}
          onRevokeInvitation={(invId) => revokeInvitation.mutate(invId)}
          revokeIsPending={revokeInvitation.isPending}
          viewerHasPendingInvite={game.viewerInvitationStatus === 'pending'}
          onDeclineInvite={() =>
            declineInvitation.mutate(undefined, {
              // A private game may 403 for the viewer once declined — leave
              // the screen rather than strand them on an error state.
              onSuccess: () => goBackOrHome(router),
            })
          }
          declineIsPending={declineInvitation.isPending}
          onRemovePlayer={(playerId) => removePlayer.mutate(playerId)}
          removeIsPending={removePlayer.isPending}
          colorPickerOpen={colorPickerOpen}
          onOpenColorPicker={() => setColorPickerOpen(true)}
          onCloseColorPicker={() => setColorPickerOpen(false)}
          onUpdateMyColor={handleUpdateMyColor}
          updateMyColorIsPending={updateMyColor.isPending}
          deleteConfirmOpen={deleteConfirmOpen}
          onConfirmDelete={confirmDelete}
          onCancelDelete={() => setDeleteConfirmOpen(false)}
        />
      )}

      {/* ── ACTIVE/COMPLETE floating overlays ──────────────────────────
          The map fills the SafeAreaView; these float on top of it.
            • Landscape cog + roster: live INSIDE the action-panel header
              (`landscapeActionHeader`), not floating over the map. The map
              therefore fills flush to the screen's right edge — there is no
              right gutter anymore (DEFAULT_RESERVED_RIGHT_LANDSCAPE === 0).
            • Portrait: cog and roster live in the top bar above the
              map (see portrait top-bar block earlier in this render).
            • The EXPANDED 75 %-width slide-in panel stays at screen
              level (PlayerRosterPanel below) because it intentionally
              covers the whole viewport behind a dim backdrop.
            • End-game modal: transparent dismissable overlay shown
              while game.status === 'COMPLETE' and the user hasn't
              dismissed it for this view yet. Map stays visible
              underneath. */}
      {(game.status === 'ACTIVE' || game.status === 'COMPLETE') && gameState && (
        <>
          {/* The Regions/Game toggle now lives INSIDE MapView via
              `regionToggleNode`, anchored to the SVG's actual bounding
              box. That's why there's no absolute-positioned chip here
              anymore — putting it at the screen level was making it
              float into the HUD area in portrait. */}

          {/* Landscape cog + roster live in the action-panel header (see
              `landscapeActionHeader` defined earlier), keeping them out of
              the map's corner overlay layer. */}

          {/* Hide the player panel during COMPLETE — the user explicitly
              asked for "we don't show users at end game, pretty much
              just the map." The collapsed strip itself is gated above
              (rosterStrip is null when not ACTIVE), so MapView's
              right-edge slot stays empty. */}
          {game.status === 'ACTIVE' && !diceLuckOpen && (
            <PlayerRosterPanel
              state={gameState}
              players={game.players}
              currentPlayerIndex={game.currentPlayerIndex}
              viewerUserId={user?.id}
              expanded={rosterExpanded}
              onCollapse={() => setRosterExpanded(false)}
              navBarBottom={navBarBottomY}
              presence={presence}
              gameId={id ?? ''}
              unreadByUser={dmUnreadByUser}
              teamChatUnread={teamUnread}
              diceLuckRows={computedDiceLuck?.players ?? snapshotDiceLuck?.players ?? null}
              diceLuckLoading={diceLuckDataState.loading}
              onShowDiceLuck={showDiceLuckEntry ? (playerId) => openDiceLuck(playerId) : undefined}
              turnStartedAt={game.bootableAt ? new Date(Date.parse(game.bootableAt) - game.bootAfterSeconds * 1000).toISOString() : currentTurnStartedAt(gameState, game.turnStartedAt)}
              isRanked={game.isRanked}
              bootableAt={game.bootableAt}
              bootAfterSeconds={game.bootAfterSeconds}
              onBootPlayer={(userId, name) => { setBootError(null); setBootTarget({ userId, name }) }}
              onShowRegion={(regionId) => {
                // Show the region ON THE CURRENT MAP with Regions view toggled
                // on — don't navigate away to the lobby map-details route.
                setRosterExpanded(false)
                setViewOverlay(CLOSED_VIEW_OVERLAY)
                setRegionDetailsMode(true)
                setFocusedRegionId(regionId)
                setFocusedDetailTerritoryId(null)
              }}
            />
          )}
          <BootPlayerConfirmation
            name={bootTarget?.name ?? null}
            botName={bootPreview.data?.botName}
            resignsInstead={bootPreview.data?.resignsInstead === true}
            turnHeld={bootPreview.data?.turnElapsedLabel}
            bootAfterSeconds={game.bootAfterSeconds}
            pending={bootPlayer.isPending}
            error={bootError ?? (bootPreview.error instanceof Error ? bootPreview.error.message : null)}
            onCancel={() => { if (!bootPlayer.isPending) setBootTarget(null) }}
            onConfirm={() => {
              if (!bootTarget) return
              bootPlayer.mutate(bootTarget.userId, {
                onSuccess: () => { setBootTarget(null); setBootError(null) },
                onError: (err) => {
                  if (err instanceof HttpError && err.code === 'ALREADY_BOT') { setBootTarget(null); void refetchGame(); return }
                  setBootError(err instanceof HttpError && err.code === 'TURN_NOT_OVERDUE' ? `${bootTarget.name} just moved — no boot needed.` : err instanceof Error ? err.message : 'Could not boot player')
                },
              })
            }}
          />

          {canOpenGameChat && chatDrawerMounted && (
            <GameChatDrawer
              gameId={id ?? ''}
              state={gameState}
              visible={chatOpen}
              navBarBottom={navBarBottomY}
              messages={messages}
              focusMessageId={chatFocusMessageId}
              currentUserId={user?.id}
              sessionSeenId={sessionSeenId}
              onSeen={markSeen}
              onClose={dismissChat}
            />
          )}

          {/* Card HUD chip lives INSIDE the placement HUD (top-right
              corner of the HUD box), threaded via ReinforceUI's
              cardChip prop above. We no longer render a floating chip
              at the screen level — turning in cards is only possible
              during placement, so the chip naturally hides when the
              placement HUD doesn't render. */}
        </>
      )}

      {shouldShowEndGameModal({ gameStatus: game.status, gameState, endGameDismissed }) && (
        <EndGameModal
          winnerName={winnerPlayer?.displayName}
          winnerSlot={winnerPlayer?.slot}
          placements={game.resultSnapshot?.placements}
          winningTeam={winningTeam ? { team: winningTeam.team, members: winningTeam.members.map((p) => ({ name: p.displayName, slot: p.slot })) } : undefined}
          onShowDiceLuck={showDiceLuckEntry ? () => openDiceLuck() : undefined}
          onClose={() => setEndGameDismissed(true)}
        />
      )}

      <DiceLuckModal
        visible={diceLuckOpen}
        onClose={() => setDiceLuckOpen(false)}
        players={game.players}
        viewerPlayerId={myPlayerId}
        initialPlayerId={diceLuckPlayerId}
        map={gameState?.map ?? null}
        result={computedDiceLuck}
        snapshot={snapshotDiceLuck}
        canGoLive={game.status === 'ACTIVE'}
        isLive={diceLuckIsLive}
        lastUpdatedAt={diceLuckLastRollAt}
        loading={diceLuckDataState.loading}
        error={Boolean(eventsError)}
        unavailable={diceLuckDataState.unavailable}
        onGoLive={() => { void refetchEvents() }}
        onViewEvent={(eventIndex) => {
          // The snapshot at that roll, in game: the modal closes over it.
          setDiceLuckOpen(false)
          setHistoricalEventIndex(eventIndex)
        }}
      />

      {/* The log grown to just under the header (the log controls' grow
          button). Same kept edges as the cards modal. */}
      {(inlineChatOn || game.status === 'COMPLETE') && gameState && !persistentChatLog ? (
        <GameLogSheet
          visible={logGrown}
          onClose={() => setLogGrown(false)}
          keepTopVisible={!isLandscape ? navBarBottomY : null}
          keepLeftVisible={null}
          // A finished game has no chat input: just the log controls.
          chatBar={inlineChatOn ? (
            <GameChatInputBar
              gameId={id ?? ''}
              expandOnFocus={!isLandscape}
              onFocusChange={setInlineChatInputFocused}
              roomy
              {...chatBarLogProps}
            />
          ) : (
            <>
              <View className="bg-paper border-b border-olive" style={{ paddingHorizontal: 8, paddingTop: 8 }}>
                <GameLogControls {...logControlProps} />
                {logFilterPanel}
              </View>
              {logFilterSummary}
            </>
          )}
          view={chatOnlyActive ? 'chat' : 'all'}
          gameId={id ?? ''}
          state={gameState}
          players={game.players}
          messages={messages}
          filters={logFilters}
          onViewAtEvent={toggleHistoricalEvent}
          selectedEventIndex={historicalEventIndex}
          eventIndexOffset={Math.max(0, (gameState.eventCount ?? 0) - (gameState.events?.length ?? 0))}
        />
      ) : null}

      {/* Player-out notice — one auto-dismissing modal per player who just left
          (eliminated or resigned). Suppressed once the game is COMPLETE so the
          winner modal (which announces the final blow) takes over. `key` per
          slot restarts the auto-dismiss timer when the queue advances. */}
      {game.status !== 'COMPLETE' &&
        eliminationQueue.length > 0 &&
        (() => {
          const notice = eliminationQueue[0]
          if (!notice) return null
          const player = game.players.find((p) => p.slot === notice.slot)
          const by =
            notice.bySlot != null
              ? game.players.find((p) => p.slot === notice.bySlot)
              : undefined
          return (
            <PlayerOutModal
              key={notice.slot}
              reason={notice.reason}
              playerName={player?.displayName ?? `Player ${notice.slot}`}
              playerSlot={notice.slot}
              bySlotName={by?.displayName ?? null}
              bySlot={notice.bySlot}
              teamOut={notice.teamOut}
              onClose={() => setEliminationQueue((q) => q.slice(1))}
            />
          )
        })()}

      {/* The hand is readable during an active game. Selecting and turning in
          cards remains limited to the viewer's own placement steps. */}
      {shouldMountTurnInCardsModal({
        gameStatus: game.status,
        gameState,
        myPlayerId,
        isMyTurn,
        isScreenFocused,
      }) && (
        <TurnInCardsModal
          // Keep the turn-in modal HIDDEN while any player-out banner is queued,
          // so the banner is always seen first. This is gated during render (not
          // just via the auto-open effect) to close a race: the banner is
          // enqueued in an effect that runs AFTER the render where
          // mustTurnInCards first flips true, so the auto-open could otherwise
          // fire before the banner exists. Visibility keys off the queue, which
          // is correct by the next render.
          visible={cardsModalOpen && eliminationQueue.length === 0}
          onClose={() => setCardsModalOpen(false)}
          gameId={id ?? ''}
          state={gameState!}
          myPlayerId={myPlayerId!}
          canTurnInCards={canTurnInCardsNow({ gameStatus: game.status, gameState, isMyTurn })}
          tutorialEnabled={tutorialEnabled}
          onTutorialEnabledChange={setTutorialEnabled}
          // Team games: teammates' hands, read-only (decision 10).
          playerName={playerDisplayName}
          // Portrait: keep the top bar visible (greyed) above the cards.
          // navBarBottomY is measured within the full-screen SafeAreaView, so
          // it is already a window y.
          keepTopVisible={!isLandscape ? navBarBottomY : null}
          // Desktop/tablet: cover only the map area; the side column stays visible.
          keepLeftVisible={persistentChatLog ? (isDesktop ? DEFAULT_RESERVED_LEFT_DESKTOP : DEFAULT_RESERVED_LEFT_LANDSCAPE) : null}
        />
      )}

      {/* ── Auto-start "preparing the game" beat ──────────────────────────
          Top layer so it covers the map + HUD while the just-started board
          hydrates underneath. Drops away once the minimum floor elapses and
          gameState is ready (see showStartingOverlay). */}
      {showStartingOverlay && <GameStartingOverlay gameName={game.name} />}
      {teamRules ? (
        <TeamRulesModal
          visible={teamRulesNotice.show && !showStartingOverlay && !inHistoricalView}
          onClose={teamRulesNotice.markSeen}
          rules={teamRules}
        />
      ) : null}
      {coachShown && !showStartingOverlay && !inHistoricalView ? (
        <FirstEntryCoachMark
          kind={coachShown}
          theme={theme}
          rulesAnchor={rulesAnchorRef}
          onGotIt={firstEntry.markSeen}
          onShow={() => {
            firstEntry.markSeen()
            setCoachShown(null)
            closeChatForRules()
            setViewOverlay({ overlay: 'map', filter: [] })
          }}
          onDone={() => setCoachShown(null)}
        />
      ) : null}
    </SafeAreaView>
    </InitialGameReveal>
    </MapChromeProvider>
    </GameOverlayTopContext.Provider>
    </ChatRowActionsProvider>
    </PlayerColorProvider>
  )
}
